<template>
  <div style="text-align:left;">
    <TopNav />
    <div class="column-left">
      <SideNav />
    </div>
    <ModalSubirArchivo ref="modalsubirarchivo" />
     <ModalEditarComision ref="modaleditarcomision" @commission-updated="handleCommissionUpdated" />

    <div v-if="deleteProfessionalModal.show" class="confirm-overlay">
      <div class="confirm-modal">
        <h4>Eliminar profesional</h4>
        <p>
          Esta accion eliminara al profesional y sus archivos.
          Las ordenes y datos de clientes se conservaran.
        </p>
        <p><strong>Esta accion no se puede deshacer.</strong></p>
        <div class="confirm-actions">
          <button class="confirm-cancel-btn" :disabled="deleteProfessionalModal.loading" @click="closeDeleteProfessionalModal">Cancelar</button>
          <button class="confirm-ok-btn" :disabled="deleteProfessionalModal.loading" @click="confirmDeleteProfessional">
            {{ deleteProfessionalModal.loading ? 'Eliminando...' : 'Si, eliminar' }}
          </button>
        </div>
      </div>
    </div>
  
    <div class="column-right">
      <div class="main-container">       
        <div v-if="loaded" class="articulo-principal">
            <div class="card shadow p-4 border-0 mb-7">
              <!-- Información Personal Section -->
              <div class="sectionv professional-info-header">
                <div class="d-flex align-items-center">
                  <img :src="profesional.foto_url || defaultAvatar" alt="Foto Profesional" class="professional-avatar">
                  <div class="ml-3">
                    <h2 class="mb-1">{{ profesional.nombre + ' ' + profesional.apellido }}</h2>
                    <div class="professional-tax-summary">
                      <span :class="['status-pill', getTipoPrestadorBadgeClass(profesional.tipo_prestador_tributario)]">
                        {{ formatTipoPrestadorTributario(profesional.tipo_prestador_tributario) }}
                      </span>
                      <span
                        v-if="profesional.tipo_prestador_tributario === 'independiente'"
                        :class="['status-pill', getSiiVerificationBadgeClass(profesional.bhe_autorizacion_estado)]"
                      >
                        {{ formatBheStatusShort(profesional.bhe_autorizacion_estado) }}
                      </span>
                    </div>
                    <div><strong>Email:</strong> {{ profesional.email }}</div>
                    <div><strong>Teléfono:</strong> {{ profesional.telefono }}</div>
                    <div v-if="profesional.descripcion" class="professional-description">
                      <strong>Descripción:</strong>
                      <p class="mb-0 professional-description-text">{{ profesional.descripcion }}</p>
                    </div>
                    <div>
                      <strong>Calificación:</strong>
                      <span v-if="profesional.clasificacion && profesional.clasificacion[0] != 0">
                        <span v-for="s in Math.trunc(profesional.clasificacion[1]/profesional.clasificacion[0])" :key="`filled-${s}`"> <b-icon class="star" icon="star-fill"></b-icon></span>
                        <span v-if="Math.trunc(profesional.clasificacion[1]/profesional.clasificacion[0]) != profesional.clasificacion[1]/profesional.clasificacion[0]">
                          <b-icon class="star" :icon="profesional.clasificacion[1]/profesional.clasificacion[0] - Math.floor(profesional.clasificacion[1]/profesional.clasificacion[0])>= 0.5 ? 'star-half' : 'star'"></b-icon>
                        </span>
                        <span v-for="s in Math.trunc(5-profesional.clasificacion[1]/profesional.clasificacion[0])" :key="`empty-${s}`"> <b-icon class="star" icon="star"></b-icon></span>
                      </span>
                      <span style="font-style: italic;" v-else> No tiene</span>
                    </div>
                    <div v-if="hasContactModerationSanction" class="contact-moderation-alert">
                      <strong>Moderación de contacto:</strong> {{ contactModerationSummary }}
                    </div>
                  </div>
                </div>
                <div class="mt-3 professional-actions">
                  <button v-on:click="actualizar_password_profesional()" class="btn btn-std mt-2 mr-2"><b-icon icon="key"></b-icon> Reiniciar password</button>
                  <button @click="toggleSuspendir()" :class="['btn', 'mt-2', 'mr-2', profesional.suspendido ? 'btn-danger' : 'btn-success']">
                    <b-icon :icon="profesional.suspendido ? 'unlock' : 'lock'"></b-icon> {{ profesional.suspendido ? 'Desactivar Suspensión' : 'Suspender' }}
                  </button>
                  <button @click="toggleRestricted()" :class="['btn', 'mt-2', 'mr-2', profesional.visibilidad_restringida ? 'btn-danger' : 'btn-success']">
                    <b-icon :icon="profesional.visibilidad_restringida ? 'eye' : 'eye-slash'"></b-icon> {{ profesional.visibilidad_restringida ? 'Desactivar Restricción' : 'Restringir Visibilidad' }}
                  </button>
                  <button @click="toggleRestrictedManual()" :class="['btn', 'mt-2', 'mr-2', profesional.visibilidad_restringida_manual ? 'btn-danger' : 'btn-success']">
                    <b-icon :icon="profesional.visibilidad_restringida_manual ? 'eye' : 'eye-slash'"></b-icon> {{ profesional.visibilidad_restringida_manual ? 'Desactivar Restricción Manual' : 'Restringir Manual' }}
                  </button>
                  <button @click="toggleOcultar()" :class="['btn', 'mt-2', profesional.oculto ? 'btn-danger' : 'btn-success']">
                    <b-icon :icon="profesional.oculto ? 'person-check' : 'person-dash'"></b-icon> {{ profesional.oculto ? 'Mostrar' : 'Ocultar' }}
                  </button>
                  <button @click="togglePrivadas()" :class="['btn', 'mt-2', profesional.solicitudes_privadas ? 'btn-danger' : 'btn-success']">
                    <b-icon :icon="profesional.solicitudes_privadas ? 'person-check' : 'person-dash'"></b-icon> {{ profesional.solicitudes_privadas ? 'Desactivar Privadas' : 'Activar Privadas' }}
                  </button>
                  <button @click="toggleSoloCompraSolicitudes()" :class="['btn', 'mt-2', profesional.solo_compra_solicitudes ? 'btn-danger' : 'btn-success']">
                    <b-icon :icon="profesional.solo_compra_solicitudes ? 'cart-x' : 'cart-check'"></b-icon> {{ profesional.solo_compra_solicitudes ? 'Desactivar Solo Compra' : 'Activar Solo Compra' }}
                  </button>
                  <button
                    v-if="hasContactModerationSanction"
                    @click="clearContactModerationSuspension()"
                    class="btn btn-warning mt-2 mr-2"
                    :disabled="clearingContactModeration"
                  >
                    <b-icon icon="unlock"></b-icon> {{ clearingContactModeration ? 'Levantando...' : 'Levantar moderación contacto' }}
                  </button>
                <button @click="showEditCommissionModal()" class="btn btn-info mt-2 ml-2"><b-icon icon="cash-coin"></b-icon> Editar Comisión</button>
                <button @click="openDeleteProfessionalModal" class="btn btn-danger mt-2 ml-2"><b-icon icon="trash"></b-icon> Eliminar profesional</button>
              </div>
            </div>

            <div class="sectionv jobbing-points-section">
              <div class="section-header">
                <div>
                  <h2>Puntos Jobbing</h2>
                  <p class="section-subtitle">Saldo disponible y compras de solicitudes.</p>
                </div>
                <span class="points-balance">{{ formatPoints(profesional.jobbing_points_balance) }} pts</span>
              </div>
              <div v-if="jobbingPointsRequestPurchases.length > 0" class="activity-list">
                <div
                  v-for="purchase in jobbingPointsRequestPurchases"
                  :key="`jobbing-points-purchase-${purchase.solicitud_id}`"
                  class="activity-item points-purchase-item"
                >
                  <div class="activity-main">
                    <router-link
                      v-if="purchase.solicitud_id"
                      class="activity-title activity-link"
                      :to="getSolicitudDetallePath(purchase.solicitud_id)"
                    >
                      {{ purchase.solicitud_titulo || `Solicitud #${purchase.solicitud_id}` }}
                    </router-link>
                    <div v-else class="activity-title">Solicitud sin ID</div>
                    <div class="activity-meta">
                      Comprada {{ formatDate(purchase.fecha_compra_puntos) }}
                      <span v-if="purchase.solicitud_id"> - #{{ purchase.solicitud_id }}</span>
                    </div>
                    <div class="activity-detail">{{ getJobbingPointsPurchaseAddress(purchase) }}</div>
                    <div v-if="purchase.restituida" class="refund-note">
                      Restituida {{ formatDate(purchase.fecha_restitucion) }}
                      <span v-if="purchase.puntos_restituidos"> - {{ formatPoints(purchase.puntos_restituidos) }} pts</span>
                    </div>
                    <div v-if="purchase.contacto_reporte" class="contact-report-note">
                      Reporte contacto: {{ contactReportStatusLabel(purchase.contacto_reporte) }}
                      <span v-if="purchase.contacto_reporte.motivo_label"> - {{ purchase.contacto_reporte.motivo_label }}</span>
                    </div>
                  </div>
                  <div class="activity-side points-purchase-side">
                    <strong>{{ formatPoints(purchase.puntos_jobbing_gastados) }} pts</strong>
                    <span>gastados</span>
                    <button
                      type="button"
                      class="btn btn-sm refund-points-btn"
                      :disabled="purchase.restituida || isRefundingPurchase(purchase)"
                      @click="refundJobbingPointsRequestPurchase(purchase)"
                    >
                      {{ purchase.restituida ? 'Restituida' : (isRefundingPurchase(purchase) ? 'Restituyendo...' : 'Restituir puntos') }}
                    </button>
                  </div>
                </div>
              </div>
              <p v-else class="empty-state">No hay compras de solicitudes con puntos.</p>
            </div>

            <div class="sectionv">
              <h2>Editar información del profesional ✏️</h2>
              <div class="edit-profile-grid">
                <div class="edit-profile-photo">
                  <img :src="editForm.fotoPreview || defaultAvatar" alt="Vista previa foto" class="photo-preview">
                  <div class="mt-2">
                    <input
                      ref="photoInput"
                      type="file"
                      accept="image/png"
                      @change="onPhotoSelected"
                      class="form-control-file"
                    >
                    <small class="form-text text-muted">Solo se permiten imágenes PNG.</small>
                  </div>
                  <button
                    class="btn btn-std mt-3"
                    :disabled="savingPhoto || !editForm.fotoFile"
                    @click="uploadProfilePhoto"
                  >
                    <b-icon icon="upload"></b-icon>
                    {{ savingPhoto ? 'Subiendo...' : 'Actualizar foto' }}
                  </button>
                </div>
                <div class="edit-profile-fields">
                  <div class="edit-profile-name-row">
                    <div class="form-group">
                      <label for="edit-nombre">Nombre</label>
                      <input id="edit-nombre" v-model="editForm.nombre" type="text" class="form-control" maxlength="250">
                    </div>
                    <div class="form-group">
                      <label for="edit-apellido">Apellido</label>
                      <input id="edit-apellido" v-model="editForm.apellido" type="text" class="form-control" maxlength="250">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="edit-email">Email</label>
                    <input id="edit-email" v-model="editForm.email" type="email" class="form-control">
                  </div>
                  <div class="form-group">
                    <label for="edit-telefono">Teléfono</label>
                    <input id="edit-telefono" v-model="editForm.telefono" type="text" class="form-control" maxlength="20">
                  </div>
                  <div class="form-group">
                    <label for="edit-descripcion">Descripción</label>
                    <textarea id="edit-descripcion" v-model="editForm.descripcion" class="form-control description-input" rows="4"></textarea>
                  </div>
                  <button
                    class="btn btn-std mt-2"
                    :disabled="savingProfile"
                    @click="updateProfesionalProfile"
                  >
                    <b-icon icon="save"></b-icon>
                    {{ savingProfile ? 'Guardando...' : 'Guardar cambios' }}
                  </button>
                </div>
              </div>
            </div>

            <div class="sectionv company-profile-section">
              <div class="section-header">
                <div>
                  <h2>Empresa o marca comercial</h2>
                  <p class="section-subtitle">
                    Información pública de la empresa asociada a este profesional.
                  </p>
                </div>
                <span :class="['company-visibility-status', profesional.empresa_perfil_visible ? 'company-visible' : 'company-hidden']">
                  {{ profesional.empresa_perfil_visible ? 'Visible en el perfil' : 'Oculta en el perfil' }}
                </span>
              </div>

              <div class="company-summary">
                <div class="company-logo-card">
                  <img
                    v-if="profesional.empresa_logo_url"
                    :src="profesional.empresa_logo_url"
                    :alt="`Foto de ${profesional.empresa_nombre_comercial || 'la empresa'}`"
                    class="company-logo"
                  >
                  <div v-else class="company-logo company-logo-placeholder" aria-label="Empresa sin foto">
                    {{ companyInitials() }}
                  </div>
                </div>
                <div class="company-information">
                  <div class="company-information-item company-information-name">
                    <strong>Nombre comercial</strong>
                    <span>{{ profesional.empresa_nombre_comercial || 'No informado' }}</span>
                  </div>
                  <div class="company-information-item">
                    <strong>RUT empresa o marca</strong>
                    <span>{{ profesional.empresa_rut_comercial || 'No informado' }}</span>
                  </div>
                  <div class="company-information-item">
                    <strong>Sitio web o Instagram</strong>
                    <a
                      v-if="profesional.empresa_web"
                      :href="companyWebsiteHref(profesional.empresa_web)"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {{ profesional.empresa_web }}
                    </a>
                    <span v-else>No informado</span>
                  </div>
                  <div class="company-information-item company-information-description">
                    <strong>Descripción</strong>
                    <span>{{ profesional.empresa_descripcion || 'No informada' }}</span>
                  </div>
                </div>
              </div>

              <div class="company-editor">
                <h3>Editar información de empresa</h3>
                <div class="company-edit-grid">
                  <div class="company-logo-editor">
                    <div class="company-logo-preview">
                      <img
                        v-if="companyForm.logoPreview"
                        :src="companyForm.logoPreview"
                        alt="Vista previa foto de empresa"
                      >
                      <span v-else>{{ companyInitials(companyForm.empresa_nombre_comercial) }}</span>
                    </div>
                    <div class="mt-2">
                      <input
                        ref="companyLogoInput"
                        type="file"
                        accept="image/png,image/jpeg,image/webp"
                        class="form-control-file"
                        @change="onCompanyLogoSelected"
                      >
                      <small class="form-text text-muted">PNG, JPG o WEBP, hasta 2 MB. Se optimizará al subirla.</small>
                    </div>
                    <div class="company-logo-actions">
                      <button
                        class="btn btn-std"
                        :disabled="savingCompanyLogo || !companyForm.logoFile"
                        @click="uploadCompanyLogo"
                      >
                        <b-icon icon="upload"></b-icon>
                        {{ savingCompanyLogo ? 'Subiendo...' : (profesional.empresa_logo_url ? 'Reemplazar foto' : 'Subir foto') }}
                      </button>
                      <button
                        v-if="profesional.empresa_logo_url"
                        class="btn btn-outline-danger"
                        :disabled="savingCompanyLogo"
                        @click="removeCompanyLogo"
                      >
                        <b-icon icon="trash"></b-icon>
                        Quitar foto
                      </button>
                    </div>
                  </div>

                  <div class="company-fields">
                    <label class="company-visibility-toggle">
                      <input v-model="companyForm.empresa_perfil_visible" type="checkbox">
                      <span>Mostrar esta empresa o marca en el perfil público del profesional</span>
                    </label>
                    <div class="company-fields-grid">
                      <div class="form-group">
                        <label for="company-name">Nombre comercial</label>
                        <input
                          id="company-name"
                          v-model="companyForm.empresa_nombre_comercial"
                          type="text"
                          class="form-control"
                          maxlength="250"
                          placeholder="Ej: Multiservicios Pérez"
                        >
                      </div>
                      <div class="form-group">
                        <label for="company-rut">RUT empresa o marca</label>
                        <input
                          id="company-rut"
                          v-model="companyForm.empresa_rut_comercial"
                          type="text"
                          class="form-control"
                          maxlength="20"
                          placeholder="77615058-4"
                        >
                      </div>
                      <div class="form-group company-web-field">
                        <label for="company-web">Sitio web o Instagram</label>
                        <input
                          id="company-web"
                          v-model="companyForm.empresa_web"
                          type="text"
                          class="form-control"
                          maxlength="255"
                          placeholder="https://miempresa.cl o @miempresa"
                        >
                      </div>
                      <div class="form-group company-description-field">
                        <label for="company-description">Descripción de la empresa o marca</label>
                        <textarea
                          id="company-description"
                          v-model="companyForm.empresa_descripcion"
                          class="form-control"
                          rows="4"
                          maxlength="500"
                          placeholder="Servicios, especialidades y experiencia de la empresa."
                        ></textarea>
                        <small class="form-text text-muted">
                          {{ (companyForm.empresa_descripcion || '').length }}/500
                        </small>
                      </div>
                    </div>
                    <button
                      class="btn btn-std mt-2"
                      :disabled="savingCompanyProfile"
                      @click="updateCompanyProfile"
                    >
                      <b-icon icon="save"></b-icon>
                      {{ savingCompanyProfile ? 'Guardando...' : 'Guardar información de empresa' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="sectionv">
              <div class="section-header">
                <div>
                  <h2>Informacion bancaria</h2>
                  <p class="section-subtitle">
                    Estos datos se usan como base al registrar transferencias al profesional.
                  </p>
                </div>
                <span :class="['bank-status', hasBankInfo() ? 'bank-status-ready' : 'bank-status-missing']">
                  {{ hasBankInfo() ? 'Completa' : 'Pendiente' }}
                </span>
              </div>
              <div class="bank-summary" v-if="hasBankInfo()">
                <div><strong>Titular:</strong> {{ profesional.nombre_transferencia }}</div>
                <div><strong>RUT titular:</strong> {{ profesional.rut_transferencia }}</div>
                <div><strong>Banco:</strong> {{ profesional.banco_nombre || formatBankName(profesional.banco_id) }}</div>
                <div><strong>Tipo de cuenta:</strong> {{ profesional.tipo_cuenta_nombre || formatAccountTypeName(profesional.tipo_cuenta_id) }}</div>
                <div><strong>Cuenta:</strong> {{ profesional.cuenta_bancaria }}</div>
              </div>
              <div class="bank-form-grid">
                <div class="form-group">
                  <label for="bank-nombre">Titular de la cuenta</label>
                  <input id="bank-nombre" v-model="bankForm.nombre_transferencia" type="text" class="form-control" maxlength="250">
                </div>
                <div class="form-group">
                  <label for="bank-rut">RUT titular</label>
                  <input id="bank-rut" v-model="bankForm.rut_transferencia" type="text" class="form-control" maxlength="13" placeholder="12345678-5">
                </div>
                <div class="form-group">
                  <label for="bank-banco">Banco</label>
                  <select id="bank-banco" v-model="bankForm.banco_id" class="form-control">
                    <option value="">Selecciona banco</option>
                    <option v-for="(bankName, bankId) in bancos" :key="`bank-${bankId}`" :value="Number(bankId)">
                      {{ bankName }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="bank-tipo">Tipo de cuenta</label>
                  <select id="bank-tipo" v-model="bankForm.tipo_cuenta_id" class="form-control">
                    <option value="">Selecciona tipo</option>
                    <option v-for="(accountTypeName, accountTypeId) in tipos_de_cuenta" :key="`account-type-${accountTypeId}`" :value="Number(accountTypeId)">
                      {{ accountTypeName }}
                    </option>
                  </select>
                </div>
                <div class="form-group bank-account-field">
                  <label for="bank-cuenta">Numero de cuenta</label>
                  <input id="bank-cuenta" v-model="bankForm.cuenta_bancaria" type="text" class="form-control" maxlength="100">
                </div>
              </div>
              <button
                class="btn btn-std mt-2"
                :disabled="savingBankInfo"
                @click="saveBankInfo"
              >
                <b-icon icon="save"></b-icon>
                {{ savingBankInfo ? 'Guardando...' : 'Guardar datos bancarios' }}
              </button>
            </div>

            <div class="sectionv">
              <h2>Clases restringidas 🚫</h2>
              <p class="restricted-helper-text">
                Define qué clases de solicitudes no podrá tomar este profesional.
              </p>
              <div class="restricted-class-options">
                <label
                  v-for="option in restrictedClassOptions"
                  :key="`restricted-class-${option.value}`"
                  class="restricted-class-option"
                >
                  <input
                    type="checkbox"
                    :id="`restricted-${option.value}`"
                    :value="option.value"
                    v-model="selectedRestrictedClasses"
                  >
                  <span>{{ option.label }}</span>
                </label>
              </div>
              <div
                v-if="selectedRestrictedClasses.length"
                class="restricted-class-selected"
              >
                <span
                  v-for="className in selectedRestrictedClasses"
                  :key="`selected-${className}`"
                  class="badge badge-restricted"
                >
                  {{ formatRestrictedClassName(className) }}
                </span>
              </div>
              <p v-else class="restricted-class-empty">
                No hay clases restringidas seleccionadas.
              </p>
              <button
                class="btn btn-std mt-2"
                :disabled="savingRestrictedClasses"
                @click="saveRestrictedClasses"
              >
                <b-icon icon="save"></b-icon>
                {{ savingRestrictedClasses ? 'Guardando...' : 'Guardar clases restringidas' }}
              </button>
            </div>

            <div class="sectionv">
              <h2>Clasificacion tributaria y SII</h2>
              <p class="restricted-helper-text">
                Define si este profesional opera como independiente o empresa. Si es independiente, desde aqui tambien puedes verificar su autorizacion SII para emitir BHE con Jobbing.
              </p>
              <div class="form-group">
                <label for="bhe-tipo-prestador">Tipo prestador tributario</label>
                <select id="bhe-tipo-prestador" v-model="bheForm.tipo_prestador_tributario" class="form-control">
                  <option value="desconocido">Desconocido</option>
                  <option value="independiente">Independiente</option>
                  <option value="empresa">Empresa</option>
                </select>
              </div>
              <div class="d-flex flex-wrap align-items-center">
                <button class="btn btn-std mt-2 mr-2" :disabled="savingBheTipo" @click="saveBheTipo">
                  <b-icon icon="save"></b-icon>
                  {{ savingBheTipo ? 'Guardando...' : 'Guardar clasificación' }}
                </button>
                <button class="btn btn-info mt-2" :disabled="verifyingBhe" @click="verifyBheAuthorization">
                  <b-icon icon="shield-check"></b-icon>
                  {{ verifyingBhe ? 'Verificando...' : 'Verificar autorización SII' }}
                </button>
              </div>
              <div class="mt-3 bhe-status-grid">
                <div><strong>Estado autorización:</strong> {{ formatBheStatus(profesional.bhe_autorizacion_estado) }}</div>
                <div><strong>Usuario Jobbing:</strong> {{ profesional.bhe_jobbing_user_rut || 'No configurado' }}</div>
                <div><strong>Último check:</strong> {{ formatDateTime(profesional.bhe_ultimo_check_at) }}</div>
                <div><strong>Expira:</strong> {{ formatDateTime(profesional.bhe_autorizacion_expira_at) }}</div>
                <div><strong>Consentimiento:</strong> {{ formatDateTime(profesional.bhe_consentimiento_at) }}</div>
                <div><strong>Error:</strong> {{ profesional.bhe_ultimo_error || 'Sin error' }}</div>
              </div>
            </div>

            <div class="sectionv">
              <h2>Clases para autoresponder 🤖</h2>
              <p class="restricted-helper-text">
                Selecciona las clases que el bot contestará automáticamente para este profesional.
              </p>
              <div class="restricted-class-options">
                <label
                  v-for="option in autoresponderClassOptions"
                  :key="`autoresponder-class-${option.value}`"
                  class="restricted-class-option"
                >
                  <input
                    type="checkbox"
                    :id="`autoresponder-${option.value}`"
                    :value="option.value"
                    v-model="selectedAutoresponderClasses"
                  >
                  <span>{{ option.label }}</span>
                </label>
              </div>
              <div
                v-if="selectedAutoresponderClasses.length"
                class="restricted-class-selected"
              >
                <span
                  v-for="className in selectedAutoresponderClasses"
                  :key="`autoresponder-selected-${className}`"
                  class="badge badge-restricted"
                >
                  {{ formatRestrictedClassName(className) }}
                </span>
              </div>
              <p v-else class="restricted-class-empty">
                El bot responderá cualquier clase de solicitud.
              </p>
              <button
                class="btn btn-std mt-2"
                :disabled="savingAutoresponderClasses"
                @click="saveAutoresponderClasses"
              >
                <b-icon icon="save"></b-icon>
                {{ savingAutoresponderClasses ? 'Guardando...' : 'Guardar clases para autoresponder' }}
              </button>
            </div>

            <!-- Horarios Section Removed -->

            <!-- Notificaciones Section -->
            <div class="sectionv">
              <h2 style="">Notificaciones 🔔</h2>
              <div class="mb-3">
                <div>
                  <strong>Notificaciones por email:</strong>
                  {{ profesional.notificaciones_email ? 'Activadas' : 'Desactivadas' }}
                </div>
                <p class="text-muted mb-2">Emails de nuevas solicitudes, respuestas y campañas.</p>
                <button
                  type="button"
                  :class="['btn', profesional.notificaciones_email ? 'btn-danger' : 'btn-success']"
                  :disabled="savingEmailNotifications"
                  @click="toggleEmailNotifications"
                >
                  <b-icon icon="envelope"></b-icon>
                  {{ savingEmailNotifications ? 'Guardando...' : (profesional.notificaciones_email ? 'Desactivar notificaciones por email' : 'Activar notificaciones por email') }}
                </button>
              </div>
              <h3 class="h6">Categorías de solicitudes</h3>
                <div v-for="c in notificaciones" :key="c.id" class="mb-1">
                  <input type="checkbox" v-model="c.active" :id="`notif-${c.id}`"> <label :for="`notif-${c.id}`" class="ml-2">{{ c.nombre }}</label>
                </div>
                <button v-on:click="actualizar_notificaciones()" style="margin-right:5px" class="btn btn-std mt-2"><b-icon icon="save"></b-icon> Guardar notificaciones</button>
              </div>
  
              <!-- Archivos Section -->
              <div class="sectionv">
                <h2 style="">Archivos 📁</h2>
                <table v-if="profesional.archivos && profesional.archivos.length" class="archivos-table">
                  <thead>
                    <tr>
                      <th>Nombre</th>
                      <th>Categoría</th>
                      <th>Tipo</th>
                      <th>Fecha Creado</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="archivo in profesional.archivos" :key="archivo.id">
                      <td>{{ archivo.nombre }}</td>
                      <td>{{ archivo.categoria }}</td>
                      <td>{{ archivo.tipo.toUpperCase() }}</td>
                      <td>{{ formatDate(archivo.fecha_creado) }}</td>
                      <td>
                        <button class="btn-std btn btn-sm" style="margin-right: 5px;" @click="descargarArchivo(archivo)">Descargar</button>
                        <button class="eliminar-btn btn-sm" @click="eliminarArchivo(archivo.id)">Eliminar</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p v-else>No hay archivos disponibles.</p>
                <button v-on:click="$refs.modalsubirarchivo.show(profesional)" style="margin-right:5px" class="btn btn-std mt-2"><b-icon icon="plus-circle"></b-icon> Agregar archivo</button>
              </div>
  
              <!-- Respuestas automáticas Section -->
              <div class="sectionv" v-if="admin_datos.superadmin">
                <h2 style="">Respuestas automáticas 🤖</h2>
                <div v-if="profesional.auto_respuesta == 1">
                  El bot de auto respuestas se encuentra <b>activado</b> para {{ profesional.nombre }}.
                </div>
                <div v-else>
                  El bot de auto respuestas se encuentra <b>desactivado</b> para {{ profesional.nombre }}.
                </div>
                <div v-on:click="cambiar_autorespuesta(profesional.id)" class="btn-activacion" :class="{'btn-activado': profesional.auto_respuesta == 1, 'btn-desactivado': profesional.auto_respuesta != 1}">
                  {{ profesional.auto_respuesta == 1 ? 'Desactivar' : 'Activar' }}
                </div>
                <div class="mt-3">
                  <p>
                    Configuración IA visible en la app:
                    <b>{{ profesional.mostrar_configuracion_ai ? 'sí' : 'no' }}</b>.
                  </p>
                  <div
                    v-on:click="actualizar_configuracion_ai(profesional.id, !profesional.mostrar_configuracion_ai)"
                    class="btn-activacion"
                    :class="{'btn-activado': profesional.mostrar_configuracion_ai, 'btn-desactivado': !profesional.mostrar_configuracion_ai}">
                    {{ profesional.mostrar_configuracion_ai ? 'Ocultar configuración IA' : 'Mostrar configuración IA' }}
                  </div>
                </div>
                <div class="mt-3">
                  <p>
                    Recordatorios "Quedo atento":
                    <b>{{ profesional.idle_followup_enabled ? 'activados' : 'desactivados' }}</b>.
                    Cuando están activos enviaremos un mensaje corto cuando el cliente deja la conversación en pausa.
                  </p>
                  <div
                    v-on:click="cambiar_idle_followup(profesional.id, !profesional.idle_followup_enabled)"
                    class="btn-activacion"
                    :class="{'btn-activado': profesional.idle_followup_enabled, 'btn-desactivado': !profesional.idle_followup_enabled}">
                    {{ profesional.idle_followup_enabled ? 'Desactivar recordatorios' : 'Activar recordatorios' }}
                  </div>
                </div>
                <div style="margin-top:10px;" v-if="profesional.auto_respuesta == 1">
                  Puedes agregar información extra para que el bot conteste al cliente
                  <textarea v-model="profesional.informacion_escondida" class="styled-textarea" placeholder="Información para el bot"></textarea>
                  <button v-on:click="guardar_informacion(profesional.id)" style="margin-right:5px" class="btn btn-std mt-2"><b-icon icon="save"></b-icon> Guardar información</button>
                </div>
              </div>
  
              <!-- Bloqueos Section Removed -->
  
              <!-- Precios Section Commented Out -->
              <!--
              <div class="sectionv">
                <h2>Precios 🏷️</h2>
                <router-link :to="{name:'ModificarPrecios', params:{profesional_id:profesional.id}}" class="btn btn-std mt-2"><b-icon icon="cash"></b-icon> Modificar precios</router-link>
              </div>  
              -->
              
              <!-- Ultimas Ordenes Section -->
              <div class="sectionv activity-section">
                <div class="section-header">
                  <div>
                    <h2>Ultimas ordenes</h2>
                    <p class="section-subtitle">Ordenes mas recientes con sus montos pagados asociados.</p>
                  </div>
                  <span class="activity-count">{{ ordenes.length }}</span>
                </div>
                <div v-if="!loaded_visitas && ordenes.length === 0" class="text-center">
                  <b-spinner small label="Cargando ordenes..."></b-spinner> Cargando ordenes...
                </div>
                <div v-else-if="ordenes.length > 0" class="activity-list">
                  <div v-for="orden in ordenes" :key="`orden-${orden.id}`" class="activity-item order-activity-item">
                    <div class="activity-main">
                      <router-link
                        v-if="getVisitSolicitudId(orden)"
                        class="activity-title activity-link"
                        :to="getSolicitudDetallePath(getVisitSolicitudId(orden))"
                      >
                        Orden #{{ orden.id }} - {{ getVisitTitle(orden) }}
                      </router-link>
                      <div v-else class="activity-title">Orden #{{ orden.id }} - {{ getVisitTitle(orden) }}</div>
                      <div class="activity-meta">
                        {{ formatDate(getVisitDate(orden)) }}
                        <span v-if="getVisitTime(orden)">a las {{ getVisitTime(orden) }}</span>
                      </div>
                      <div class="activity-detail">{{ getVisitAddress(orden) }}</div>
                      <div v-if="getOrderPayments(orden).length" class="payment-chip-list">
                        <span
                          v-for="pago in getOrderPayments(orden)"
                          :key="`orden-${orden.id}-pago-${pago.id}`"
                          class="payment-chip"
                        >
                          {{ formatCurrency(pago.monto) }} - {{ getEstadoPago(pago.estado) }}
                        </span>
                      </div>
                    </div>
                    <div class="activity-side">
                      <strong>{{ formatCurrency(getOrderPaidTotal(orden)) }}</strong>
                      <span>pagado</span>
                      <small>{{ getEstadoVisita(orden.estado) }}</small>
                    </div>
                  </div>
                </div>
                <p v-else class="empty-state">No hay ordenes registradas.</p>
              </div>
  
              <!-- Ultimas Solicitudes Contestadas Section -->
              <div class="sectionv activity-section">
                <div class="section-header">
                  <div>
                    <h2>Ultimas solicitudes contestadas</h2>
                    <p class="section-subtitle">Solicitudes donde el profesional respondio, con el chat asociado.</p>
                  </div>
                  <span class="activity-count">{{ latestSolicitudesContestadas.length }}</span>
                </div>
                <div v-if="!loaded_respuestas && latestSolicitudesContestadas.length === 0" class="text-center">
                  <b-spinner small label="Cargando solicitudes..."></b-spinner> Cargando solicitudes...
                </div>
                <div v-else-if="latestSolicitudesContestadas.length > 0" class="activity-list">
                  <div
                    v-for="solicitud in latestSolicitudesContestadas"
                    :key="`solicitud-contestada-${solicitud.id}`"
                    class="activity-item answered-request-item"
                  >
                    <div class="activity-main">
                      <div class="activity-title">
                        <router-link
                          class="activity-link"
                          :to="getSolicitudDetallePath(solicitud.id)"
                        >
                          {{ solicitud.titulo || `Solicitud #${solicitud.id}` }}
                        </router-link>
                      </div>
                      <div class="activity-meta">
                        Ultima respuesta {{ formatDate(solicitud.ultima_respuesta_fecha) }}
                        <span v-if="solicitud.is_public_solicitud"> · Publica</span>
                      </div>
                      <div class="activity-detail">{{ solicitud.direccion || 'Sin direccion asociada' }}</div>
                      <button
                        type="button"
                        class="activity-toggle"
                        @click="toggleAnsweredRequest(solicitud.id)"
                      >
                        {{ chatToggleLabel(solicitud) }}
                      </button>
                      <div v-if="isAnsweredRequestExpanded(solicitud.id)" class="chat-preview">
                        <div
                          v-for="mensaje in solicitud.mensajes_chat.slice(-5)"
                          :key="`solicitud-${solicitud.id}-mensaje-${mensaje.sender_type}-${mensaje.id}`"
                          class="chat-preview-message"
                          :class="messagePreviewClass(mensaje)"
                        >
                          <span>{{ messageSenderLabel(mensaje) }}</span>
                          <p>{{ truncateText(mensaje.mensaje, 180) }}</p>
                          <small>{{ formatDate(mensaje.fecha) }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <p v-else class="empty-state">No hay solicitudes contestadas.</p>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
  </template>
  
  <script>
  import axios from 'axios';
  import { mapGetters, mapActions } from 'vuex';
  // Fuse is not used anymore with the calendar removal, but kept if needed elsewhere
  // import Fuse from 'fuse.js' 
import SideNav from '@/components/SideNav.vue';
import TopNav from '@/components/TopNav.vue';
import ModalSubirArchivo from '@/views/superadmin/ModalSubirArchivo.vue'; // Ensure path is correct
import ModalEditarComision from '@/components/ModalEditarComision.vue'; // Import new modal

const DEFAULT_PROFESSIONAL_AVATAR = 'https://via.placeholder.com/100';

export default {
    name: 'ProfesionalDetalleModern', // Renamed for clarity
    props: ['id'],
    components: {
      SideNav,
      TopNav,
      ModalSubirArchivo,
      ModalEditarComision, // Register new modal
    },
    data() {
      return {
        loaded: false,
        profesional: { // Initialize profesional to avoid undefined errors on render
          nombre: '',
          apellido: '',
          email: '',
          telefono: '',
          descripcion: '',
          clasificacion: [0,0],
          archivos: [],
          notificaciones: [],
          notificaciones_email: true,
          clases_restringidas: [],
          autoresponder_clases: [],
          mostrar_configuracion_ai: false,
          solo_compra_solicitudes: false,
          jobbing_points_balance: 0,
          jobbing_points_request_purchases: [],
          foto_url: '',
          empresa_perfil_visible: false,
          empresa_nombre_comercial: '',
          empresa_rut_comercial: '',
          empresa_web: '',
          empresa_descripcion: '',
          empresa_logo_s3_key: '',
          empresa_logo_url: '',
          tipo_prestador_tributario: 'desconocido',
          bhe_autorizacion_estado: 'pendiente_autorizacion_sii',
          nombre_transferencia: '',
          rut_transferencia: '',
          banco_id: '',
          banco_nombre: '',
          tipo_cuenta_id: '',
          tipo_cuenta_nombre: '',
          cuenta_bancaria: '',
          contact_moderation_strikes: 0,
          contact_moderation_suspended_until: null,
          contact_moderation_permanent: false,
          contact_moderation_last_action: null,
          contact_moderation_last_violation_at: null,
          contact_moderation_active: false,
          contact_moderation_recent_events: [],
        },
        defaultAvatar: DEFAULT_PROFESSIONAL_AVATAR,
        editForm: {
          nombre: '',
          apellido: '',
          email: '',
          telefono: '',
          descripcion: '',
          fotoPreview: DEFAULT_PROFESSIONAL_AVATAR,
          fotoFile: null,
        },
        photoPreviewObjectUrl: null,
        savingProfile: false,
        savingPhoto: false,
        companyForm: {
          empresa_perfil_visible: false,
          empresa_nombre_comercial: '',
          empresa_rut_comercial: '',
          empresa_web: '',
          empresa_descripcion: '',
          logoPreview: null,
          logoFile: null,
        },
        companyLogoPreviewObjectUrl: null,
        savingCompanyProfile: false,
        savingCompanyLogo: false,
        bancos: {},
        tipos_de_cuenta: {},
        bankForm: {
          nombre_transferencia: '',
          rut_transferencia: '',
          banco_id: '',
          tipo_cuenta_id: '',
          cuenta_bancaria: '',
        },
        savingBankInfo: false,
        bheForm: {
          tipo_prestador_tributario: 'desconocido',
        },
        savingBheTipo: false,
        verifyingBhe: false,
        clearingContactModeration: false,
        savingEmailNotifications: false,
        notificaciones: [],

        ordenes: [],
        loaded_visitas: false,
        expandedAnsweredRequests: {},
  
        latestRespuestas: [
          // Example Data (remove when API is ready)
          // { id: 1, mensaje: "Estaré allí en 15 minutos.", fecha: new Date(), solicitud: { id: 101, titulo: "Fuga de agua urgente", direccion: "Av. Siempre Viva 742", comuna: { nombre: "Springfield" }, descripcion: "La llave principal no cierra y el agua sigue saliendo." }},
          // { id: 2, mensaje: "El trabajo ha sido completado.", fecha: new Date(Date.now() - 86400000), solicitud: { id: 102, titulo: "Instalar nueva lámpara", direccion: "Calle Falsa 123", comuna: { nombre: "Providencia" }, descripcion: "Compré una lámpara de techo y necesito que la instalen." }}
        ],
        loaded_respuestas: false,
  
        latestPagos: [
          // Example Data (remove when API is ready)
          // { id: 1, orden_id: 201, monto: 50000, fecha_pagado: new Date(), metodo_pago: "Transferencia", estado: 1 },
          // { id: 2, orden_id: 202, monto: 75000, fecha_pagado: new Date(Date.now() - 172800000), metodo_pago: "Webpay", estado: 1 }
        ],
        loaded_pagos: false,
        jobbingPointsRefunding: {},

        restrictedClassOptions: [
          { value: 'chica', label: 'Chica' },
          { value: 'mediana', label: 'Mediana' },
          { value: 'grande', label: 'Grande' },
          { value: 'desconocida', label: 'Desconocida' },
          { value: 'sin_identificar', label: 'Sin identificar' }
        ],
        selectedRestrictedClasses: [],
        savingRestrictedClasses: false,
        autoresponderClassOptions: [
          { value: 'chica', label: 'Chica' },
          { value: 'mediana', label: 'Mediana' },
          { value: 'grande', label: 'Grande' },
          { value: 'desconocida', label: 'Desconocida' },
          { value: 'sin_identificar', label: 'Sin identificar' }
        ],
        selectedAutoresponderClasses: [],
        savingAutoresponderClasses: false,

        deleteProfessionalModal: {
          show: false,
          loading: false,
        },

        // Removed calendar specific data: hastaD, desdeD, viendoAño, viendoDia, viendoMes, hoyMes, hoyDia, hoyAño, mapping, meses, dias, dias2
      }
    },
    created() {
      this.initialize_();
      // Removed calendar specific date initializations
    },

    beforeDestroy() {
      if (this.photoPreviewObjectUrl) {
        URL.revokeObjectURL(this.photoPreviewObjectUrl);
        this.photoPreviewObjectUrl = null;
      }
      if (this.companyLogoPreviewObjectUrl) {
        URL.revokeObjectURL(this.companyLogoPreviewObjectUrl);
        this.companyLogoPreviewObjectUrl = null;
      }
    },

    methods: {
      ...mapActions(['initialize']), // Keep if 'initialize' from Vuex is used for general app init

      openDeleteProfessionalModal() {
        this.deleteProfessionalModal.show = true;
      },
      closeDeleteProfessionalModal() {
        if (this.deleteProfessionalModal.loading) {
          return;
        }
        this.deleteProfessionalModal.show = false;
      },
      confirmDeleteProfessional() {
        if (!this.profesional || !this.profesional.id || this.deleteProfessionalModal.loading) {
          return;
        }

        this.deleteProfessionalModal.loading = true;
        axios.post(window.hostname + 'api/admin/eliminar_profesional', { profesional_id: this.profesional.id })
          .then(() => {
            this.$notify({ group: 'foos', title: 'Exito', text: 'Profesional eliminado correctamente.', type: 'success' });
            this.deleteProfessionalModal.show = false;
            this.$router.push({ name: 'VerProfesionales' });
          })
          .catch(error => {
            const message = error.response?.data?.message || 'Error al eliminar el profesional.';
            this.$notify({ group: 'foos', title: 'Error', text: message, type: 'error' });
          })
          .finally(() => {
            this.deleteProfessionalModal.loading = false;
          });
      },

      showEditCommissionModal() {
        if (this.profesional && this.profesional.id) {
          // Pass the entire profesional object, as ModalEditarComision expects it
          // and extracts needed fields like id, nombre, apellido, margen_captacion, commission_tiers
          this.$refs.modaleditarcomision.show(this.profesional);
        } else {
          this.$notify({ group: 'foos', title: 'Error', text: 'Datos del profesional no cargados.', type: 'error' });
        }
      },
      handleCommissionUpdated() {
        this.$notify({ group: 'foos', title: 'Éxito', text: 'Comisión actualizada correctamente.', type: 'success' });
        this.initialize_(false); // Re-fetch professional data without full page load spinner
      },
      syncEditForm() {
        if (!this.profesional) {
          return;
        }

        this.editForm.email = this.profesional.email || '';
        this.editForm.nombre = this.profesional.nombre || '';
        this.editForm.apellido = this.profesional.apellido || '';
        this.editForm.telefono = this.profesional.telefono || '';
        this.editForm.descripcion = this.profesional.descripcion || '';
        this.editForm.fotoPreview = (this.profesional.foto_url && this.profesional.foto_url.length)
          ? this.profesional.foto_url
          : this.defaultAvatar;
        this.editForm.fotoFile = null;

        if (this.photoPreviewObjectUrl) {
          URL.revokeObjectURL(this.photoPreviewObjectUrl);
          this.photoPreviewObjectUrl = null;
        }

        if (this.$refs.photoInput) {
          this.$refs.photoInput.value = '';
        }
      },
      syncCompanyForm() {
        const profesional = this.profesional || {};
        this.companyForm.empresa_perfil_visible = !!profesional.empresa_perfil_visible;
        this.companyForm.empresa_nombre_comercial = profesional.empresa_nombre_comercial || '';
        this.companyForm.empresa_rut_comercial = profesional.empresa_rut_comercial || '';
        this.companyForm.empresa_web = profesional.empresa_web || '';
        this.companyForm.empresa_descripcion = profesional.empresa_descripcion || '';
        this.companyForm.logoPreview = profesional.empresa_logo_url || null;
        this.companyForm.logoFile = null;

        if (this.companyLogoPreviewObjectUrl) {
          URL.revokeObjectURL(this.companyLogoPreviewObjectUrl);
          this.companyLogoPreviewObjectUrl = null;
        }

        if (this.$refs.companyLogoInput) {
          this.$refs.companyLogoInput.value = '';
        }
      },
      companyInitials(companyName = null) {
        const name = companyName === null
          ? this.profesional?.empresa_nombre_comercial
          : companyName;
        const words = String(name || '')
          .trim()
          .split(/\s+/)
          .filter(Boolean);
        if (!words.length) return 'EM';
        const first = words[0]?.charAt(0) || 'E';
        const second = words[1]?.charAt(0) || words[0]?.charAt(1) || 'M';
        return `${first}${second}`.toUpperCase();
      },
      companyWebsiteHref(value) {
        const website = String(value || '').trim();
        if (!website) return '#';
        if (/^https?:\/\//i.test(website)) return website;
        if (website.charAt(0) === '@') {
          return `https://www.instagram.com/${website.slice(1)}`;
        }
        return `https://${website}`;
      },
      onCompanyLogoSelected(event) {
        const file = event.target.files && event.target.files[0];
        if (!file) {
          this.companyForm.logoFile = null;
          this.companyForm.logoPreview = this.profesional.empresa_logo_url || null;
          return;
        }

        const allowedTypes = ['image/png', 'image/jpeg', 'image/webp'];
        if (!allowedTypes.includes(file.type)) {
          this.$notify({
            group: 'foos',
            title: 'Archivo no válido',
            text: 'Selecciona una imagen PNG, JPG o WEBP.',
            type: 'error',
          });
          event.target.value = '';
          this.companyForm.logoFile = null;
          this.companyForm.logoPreview = this.profesional.empresa_logo_url || null;
          return;
        }

        const maxFileSize = 2 * 1024 * 1024;
        if (file.size > maxFileSize) {
          this.$notify({
            group: 'foos',
            title: 'Archivo muy grande',
            text: 'La foto de empresa no puede superar los 2 MB.',
            type: 'error',
          });
          event.target.value = '';
          this.companyForm.logoFile = null;
          this.companyForm.logoPreview = this.profesional.empresa_logo_url || null;
          return;
        }

        if (this.companyLogoPreviewObjectUrl) {
          URL.revokeObjectURL(this.companyLogoPreviewObjectUrl);
        }
        this.companyLogoPreviewObjectUrl = URL.createObjectURL(file);
        this.companyForm.logoFile = file;
        this.companyForm.logoPreview = this.companyLogoPreviewObjectUrl;
      },
      uploadCompanyLogo() {
        if (!this.profesional?.id || !this.companyForm.logoFile) {
          this.$notify({
            group: 'foos',
            title: 'Error',
            text: 'Selecciona una foto para la empresa.',
            type: 'error',
          });
          return;
        }

        const formData = new FormData();
        formData.append('profesional_id', this.profesional.id);
        formData.append('image', this.companyForm.logoFile);
        this.savingCompanyLogo = true;

        axios.post(window.hostname + 'api/admin/profesional/update_company_logo', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then(response => {
            const imageUrl = response.data?.empresa_logo_url || '';
            const cacheBustedUrl = imageUrl ? `${imageUrl}?t=${Date.now()}` : '';
            this.profesional.empresa_logo_s3_key = response.data?.empresa_logo_s3_key || '';
            this.profesional.empresa_logo_url = cacheBustedUrl;
            this.companyForm.logoPreview = cacheBustedUrl || null;
            this.companyForm.logoFile = null;
            if (this.$refs.companyLogoInput) {
              this.$refs.companyLogoInput.value = '';
            }
            if (this.companyLogoPreviewObjectUrl) {
              URL.revokeObjectURL(this.companyLogoPreviewObjectUrl);
              this.companyLogoPreviewObjectUrl = null;
            }
            this.$notify({
              group: 'foos',
              title: 'Éxito',
              text: 'Foto de empresa actualizada.',
              type: 'success',
            });
          })
          .catch(error => {
            const message = error.response?.data?.message || 'Error al actualizar la foto de empresa.';
            this.$notify({ group: 'foos', title: 'Error', text: message, type: 'error' });
          })
          .finally(() => {
            this.savingCompanyLogo = false;
          });
      },
      removeCompanyLogo() {
        if (!this.profesional?.id || !this.profesional.empresa_logo_url) {
          return;
        }
        if (!window.confirm('¿Quitar la foto de esta empresa?')) {
          return;
        }

        const formData = new FormData();
        formData.append('profesional_id', this.profesional.id);
        formData.append('remove_logo', 'true');
        this.savingCompanyLogo = true;

        axios.post(window.hostname + 'api/admin/profesional/update_company_logo', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then(() => {
            this.profesional.empresa_logo_s3_key = '';
            this.profesional.empresa_logo_url = '';
            this.companyForm.logoPreview = null;
            this.companyForm.logoFile = null;
            if (this.$refs.companyLogoInput) {
              this.$refs.companyLogoInput.value = '';
            }
            if (this.companyLogoPreviewObjectUrl) {
              URL.revokeObjectURL(this.companyLogoPreviewObjectUrl);
              this.companyLogoPreviewObjectUrl = null;
            }
            this.$notify({
              group: 'foos',
              title: 'Éxito',
              text: 'Foto de empresa eliminada.',
              type: 'success',
            });
          })
          .catch(error => {
            const message = error.response?.data?.message || 'Error al quitar la foto de empresa.';
            this.$notify({ group: 'foos', title: 'Error', text: message, type: 'error' });
          })
          .finally(() => {
            this.savingCompanyLogo = false;
          });
      },
      updateCompanyProfile() {
        if (!this.profesional?.id) {
          this.$notify({ group: 'foos', title: 'Error', text: 'Profesional no encontrado.', type: 'error' });
          return;
        }

        const payload = {
          profesional_id: this.profesional.id,
          empresa_perfil_visible: !!this.companyForm.empresa_perfil_visible,
          empresa_nombre_comercial: (this.companyForm.empresa_nombre_comercial || '').trim(),
          empresa_rut_comercial: (this.companyForm.empresa_rut_comercial || '').trim(),
          empresa_web: (this.companyForm.empresa_web || '').trim(),
          empresa_descripcion: (this.companyForm.empresa_descripcion || '').trim(),
        };

        if (payload.empresa_perfil_visible && !payload.empresa_nombre_comercial) {
          this.$notify({
            group: 'foos',
            title: 'Falta información',
            text: 'Ingresa el nombre comercial para mostrar la empresa en el perfil.',
            type: 'error',
          });
          return;
        }

        this.savingCompanyProfile = true;
        axios.post(window.hostname + 'api/admin/profesional/update_company_profile', payload)
          .then(response => {
            const updated = response.data?.company_profile || {};
            const fields = [
              'empresa_perfil_visible',
              'empresa_nombre_comercial',
              'empresa_rut_comercial',
              'empresa_web',
              'empresa_descripcion',
            ];
            fields.forEach(field => {
              if (Object.prototype.hasOwnProperty.call(updated, field)) {
                this.profesional[field] = updated[field];
                this.companyForm[field] = field === 'empresa_perfil_visible'
                  ? !!updated[field]
                  : (updated[field] || '');
              }
            });
            this.$notify({
              group: 'foos',
              title: 'Éxito',
              text: 'Información de empresa actualizada.',
              type: 'success',
            });
          })
          .catch(error => {
            const message = error.response?.data?.message || 'Error al actualizar la información de empresa.';
            this.$notify({ group: 'foos', title: 'Error', text: message, type: 'error' });
          })
          .finally(() => {
            this.savingCompanyProfile = false;
          });
      },
      syncBankForm() {
        const profesional = this.profesional || {};
        this.bankForm.nombre_transferencia = profesional.nombre_transferencia || '';
        this.bankForm.rut_transferencia = profesional.rut_transferencia || '';
        this.bankForm.banco_id = profesional.banco_id || '';
        this.bankForm.tipo_cuenta_id = profesional.tipo_cuenta_id || '';
        this.bankForm.cuenta_bancaria = profesional.cuenta_bancaria || '';
      },
      hasBankInfo() {
        return !!(
          this.profesional &&
          this.profesional.nombre_transferencia &&
          this.profesional.rut_transferencia &&
          this.profesional.banco_id &&
          this.profesional.tipo_cuenta_id &&
          this.profesional.cuenta_bancaria
        );
      },
      formatBankName(bankId) {
        if (!bankId || !this.bancos) return 'No configurado';
        return this.bancos[String(bankId)] || this.bancos[bankId] || `Banco #${bankId}`;
      },
      formatAccountTypeName(accountTypeId) {
        if (!accountTypeId || !this.tipos_de_cuenta) return 'No configurado';
        return this.tipos_de_cuenta[String(accountTypeId)] || this.tipos_de_cuenta[accountTypeId] || `Tipo #${accountTypeId}`;
      },
      syncBheForm() {
        this.bheForm.tipo_prestador_tributario = this.profesional?.tipo_prestador_tributario || 'desconocido';
      },
      formatDateTime(value) {
        if (!value) return 'N/A';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return 'N/A';
        return date.toLocaleString('es-CL');
      },
      formatBheStatus(value) {
        const labels = {
          pendiente_autorizacion_sii: 'Pendiente autorización SII',
          autorizacion_verificada: 'Autorización verificada',
          autorizacion_fallida: 'Autorización fallida',
          autorizacion_expirada: 'Autorización expirada',
          autorizacion_revocada_o_invalida: 'Revocada o inválida',
        };
        return labels[value] || 'Sin estado';
      },
      formatBheStatusShort(value) {
        if (value === 'autorizacion_verificada') {
          return 'SII verificado';
        }
        if (
          value === 'autorizacion_fallida' ||
          value === 'autorizacion_expirada' ||
          value === 'autorizacion_revocada_o_invalida'
        ) {
          return 'SII no verificado';
        }
        return 'SII pendiente';
      },
      formatTipoPrestadorTributario(value) {
        if (value === 'independiente') {
          return 'Independiente';
        }
        if (value === 'empresa') {
          return 'Empresa';
        }
        return 'Sin clasificar';
      },
      getTipoPrestadorBadgeClass(value) {
        if (value === 'independiente') {
          return 'status-pill-independent';
        }
        if (value === 'empresa') {
          return 'status-pill-company';
        }
        return 'status-pill-unknown';
      },
      getSiiVerificationBadgeClass(value) {
        if (value === 'autorizacion_verificada') {
          return 'status-pill-verified';
        }
        if (
          value === 'autorizacion_fallida' ||
          value === 'autorizacion_expirada' ||
          value === 'autorizacion_revocada_o_invalida'
        ) {
          return 'status-pill-not-verified';
        }
        return 'status-pill-pending';
      },
      saveBheTipo() {
        if (!this.profesional || !this.profesional.id) {
          return;
        }
        this.savingBheTipo = true;
        axios.post(window.hostname + 'api/admin/profesional/tributario/update', {
          profesional_id: this.profesional.id,
          tipo_prestador_tributario: this.bheForm.tipo_prestador_tributario,
        })
          .then(response => {
            const bheStatus = response.data?.bhe_status || {};
            this.profesional.tipo_prestador_tributario = bheStatus.tipo_prestador_tributario || this.bheForm.tipo_prestador_tributario;
            this.profesional = { ...this.profesional, ...bheStatus };
            this.syncBheForm();
            this.$notify({ group: 'foos', title: 'Éxito', text: 'Clasificación tributaria actualizada.', type: 'success' });
          })
          .catch(error => {
            const message = error.response?.data?.message || 'No se pudo actualizar la clasificación tributaria.';
            this.$notify({ group: 'foos', title: 'Error', text: message, type: 'error' });
          })
          .finally(() => {
            this.savingBheTipo = false;
          });
      },
      verifyBheAuthorization() {
        if (!this.profesional || !this.profesional.id) {
          return;
        }
        this.verifyingBhe = true;
        axios.post(window.hostname + 'api/admin/profesional/bhe/verify', {
          profesional_id: this.profesional.id,
        })
          .then(response => {
            const bheStatus = response.data?.bhe_status || {};
            this.profesional = { ...this.profesional, ...bheStatus };
            this.syncBheForm();
            this.$notify({ group: 'foos', title: 'Éxito', text: response.data?.message || 'Autorización BHE verificada.', type: 'success' });
          })
          .catch(error => {
            const bheStatus = error.response?.data?.bhe_status || null;
            if (bheStatus) {
              this.profesional = { ...this.profesional, ...bheStatus };
              this.syncBheForm();
            }
            const message = error.response?.data?.message || 'No se pudo verificar la autorización BHE.';
            this.$notify({ group: 'foos', title: 'Error', text: message, type: 'error' });
          })
          .finally(() => {
            this.verifyingBhe = false;
          });
      },
      onPhotoSelected(event) {
        const files = event?.target?.files || [];

        if (!files.length) {
          this.editForm.fotoFile = null;
          this.editForm.fotoPreview = this.profesional.foto_url || this.defaultAvatar;
          if (this.photoPreviewObjectUrl) {
            URL.revokeObjectURL(this.photoPreviewObjectUrl);
            this.photoPreviewObjectUrl = null;
          }
          return;
        }

        const file = files[0];
        if (!file) {
          return;
        }

        if (file.type !== 'image/png') {
          this.$notify({
            group: 'foos',
            title: 'Archivo inválido',
            text: 'Solo se permiten imágenes PNG.',
            type: 'error',
          });
          if (this.photoPreviewObjectUrl) {
            URL.revokeObjectURL(this.photoPreviewObjectUrl);
            this.photoPreviewObjectUrl = null;
          }
          this.editForm.fotoFile = null;
          this.editForm.fotoPreview = this.profesional.foto_url || this.defaultAvatar;
          if (event && event.target) {
            event.target.value = '';
          }
          return;
        }

        if (this.photoPreviewObjectUrl) {
          URL.revokeObjectURL(this.photoPreviewObjectUrl);
        }

        this.photoPreviewObjectUrl = URL.createObjectURL(file);
        this.editForm.fotoFile = file;
        this.editForm.fotoPreview = this.photoPreviewObjectUrl;
      },
      uploadProfilePhoto() {
        if (!this.profesional || !this.profesional.id) {
          this.$notify({ group: 'foos', title: 'Error', text: 'Profesional no encontrado.', type: 'error' });
          return;
        }

        if (!this.editForm.fotoFile) {
          this.$notify({ group: 'foos', title: 'Error', text: 'Selecciona una imagen PNG.', type: 'error' });
          return;
        }

        const formData = new FormData();
        formData.append('profesional_id', this.profesional.id);
        formData.append('image', this.editForm.fotoFile);

        this.savingPhoto = true;

        axios.post(window.hostname + 'api/admin/profesional/upload_profile_img', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then(response => {
            const imageUrl = response.data?.imageUrl || '';
            const cacheBustedUrl = imageUrl ? `${imageUrl}?t=${Date.now()}` : '';
            this.profesional.foto_url = cacheBustedUrl;
            this.editForm.fotoPreview = cacheBustedUrl || this.defaultAvatar;
            this.editForm.fotoFile = null;
            if (this.$refs.photoInput) {
              this.$refs.photoInput.value = '';
            }
            if (this.photoPreviewObjectUrl) {
              URL.revokeObjectURL(this.photoPreviewObjectUrl);
              this.photoPreviewObjectUrl = null;
            }
            this.$notify({ group: 'foos', title: 'Éxito', text: 'Foto de perfil actualizada.', type: 'success' });
          })
          .catch(error => {
            const message = error.response?.data?.message || 'Error al actualizar la foto.';
            this.$notify({ group: 'foos', title: '¡Error!', text: message, type: 'error' });
          })
          .finally(() => {
            this.savingPhoto = false;
          });
      },
      updateProfesionalProfile() {
        if (!this.profesional || !this.profesional.id) {
          this.$notify({ group: 'foos', title: 'Error', text: 'Profesional no encontrado.', type: 'error' });
          return;
        }

        const payload = {
          profesional_id: this.profesional.id,
          nombre: this.editForm.nombre ? this.editForm.nombre.trim() : '',
          apellido: this.editForm.apellido ? this.editForm.apellido.trim() : '',
          email: this.editForm.email ? this.editForm.email.trim() : '',
          telefono: this.editForm.telefono ? this.editForm.telefono.trim() : '',
          descripcion: this.editForm.descripcion || '',
        };

        if (!payload.nombre) {
          this.$notify({ group: 'foos', title: 'Error', text: 'El nombre es obligatorio.', type: 'error' });
          return;
        }

        if (!payload.apellido) {
          this.$notify({ group: 'foos', title: 'Error', text: 'El apellido es obligatorio.', type: 'error' });
          return;
        }

        if (!payload.email) {
          this.$notify({ group: 'foos', title: 'Error', text: 'El correo electrónico es obligatorio.', type: 'error' });
          return;
        }

        this.savingProfile = true;

        axios.post(window.hostname + 'api/admin/profesional/update_profile', payload)
          .then(response => {
            const updated = response.data?.profesional || {};

            if (Object.prototype.hasOwnProperty.call(updated, 'nombre')) {
              this.profesional.nombre = updated.nombre || '';
              this.editForm.nombre = updated.nombre || '';
            }

            if (Object.prototype.hasOwnProperty.call(updated, 'apellido')) {
              this.profesional.apellido = updated.apellido || '';
              this.editForm.apellido = updated.apellido || '';
            }

            if (Object.prototype.hasOwnProperty.call(updated, 'email')) {
              this.profesional.email = updated.email || '';
              this.editForm.email = updated.email || '';
            }

            if (Object.prototype.hasOwnProperty.call(updated, 'telefono')) {
              this.profesional.telefono = updated.telefono || '';
              this.editForm.telefono = updated.telefono || '';
            }

            if (Object.prototype.hasOwnProperty.call(updated, 'descripcion')) {
              this.profesional.descripcion = updated.descripcion || '';
              this.editForm.descripcion = updated.descripcion || '';
            }

            this.$notify({ group: 'foos', title: 'Éxito', text: 'Información actualizada correctamente.', type: 'success' });
          })
          .catch(error => {
            const message = error.response?.data?.message || 'Error al actualizar la información.';
            this.$notify({ group: 'foos', title: '¡Error!', text: message, type: 'error' });
          })
          .finally(() => {
            this.savingProfile = false;
          });
      },
      saveBankInfo() {
        if (!this.profesional || !this.profesional.id) {
          this.$notify({ group: 'foos', title: 'Error', text: 'Profesional no encontrado.', type: 'error' });
          return;
        }

        const payload = {
          profesional_id: this.profesional.id,
          nombre_transferencia: this.bankForm.nombre_transferencia ? this.bankForm.nombre_transferencia.trim() : '',
          rut_transferencia: this.bankForm.rut_transferencia ? this.bankForm.rut_transferencia.trim() : '',
          banco_id: this.bankForm.banco_id,
          tipo_cuenta_id: this.bankForm.tipo_cuenta_id,
          cuenta_bancaria: this.bankForm.cuenta_bancaria ? this.bankForm.cuenta_bancaria.trim() : '',
        };

        if (!payload.nombre_transferencia || !payload.rut_transferencia || !payload.banco_id || !payload.tipo_cuenta_id || !payload.cuenta_bancaria) {
          this.$notify({ group: 'foos', title: 'Error', text: 'Completa todos los datos bancarios.', type: 'error' });
          return;
        }

        this.savingBankInfo = true;

        axios.post(window.hostname + 'api/admin/profesional/update_bank_info', payload)
          .then(response => {
            const bankInfo = response.data && response.data.bank_info ? response.data.bank_info : payload;
            this.profesional = { ...this.profesional, ...bankInfo };
            this.syncBankForm();
            this.$notify({ group: 'foos', title: 'Exito', text: 'Datos bancarios actualizados.', type: 'success' });
          })
          .catch(error => {
            const message = error.response?.data?.message || 'Error al actualizar los datos bancarios.';
            this.$notify({ group: 'foos', title: 'Error', text: message, type: 'error' });
          })
          .finally(() => {
            this.savingBankInfo = false;
          });
      },

      refreshRestrictedClassSelection() {
        const clasesOrigen = this.profesional && Array.isArray(this.profesional.clases_restringidas)
          ? this.profesional.clases_restringidas
          : [];
        const clases = [...clasesOrigen];
        this.selectedRestrictedClasses = clases;
      },
      refreshAutoresponderClassSelection() {
        const clasesOrigen = this.profesional && Array.isArray(this.profesional.autoresponder_clases)
          ? this.profesional.autoresponder_clases
          : [];
        this.selectedAutoresponderClasses = [...clasesOrigen];
      },
      formatRestrictedClassName(className) {
        if (!className || typeof className !== 'string') return '';
        if (className === 'desconocida') {
          return 'Desconocida';
        }
        if (className === 'sin_identificar') {
          return 'Sin identificar';
        }
        return className.charAt(0).toUpperCase() + className.slice(1);
      },
      saveRestrictedClasses() {
        if (!this.profesional || !this.profesional.id) {
          this.$notify({ group: 'foos', title: 'Error', text: 'Profesional no encontrado.', type: 'error' });
          return;
        }

        this.savingRestrictedClasses = true;
        axios.post(window.hostname + 'api/admin/profesional/restricted_clases', {
          profesional_id: this.profesional.id,
          clases: this.selectedRestrictedClasses,
        })
          .then(response => {
            const newClases = response.data?.restricted_clases || [];
            this.profesional.clases_restringidas = newClases;
            this.refreshRestrictedClassSelection();
            this.$notify({ group: 'foos', title: 'Éxito', text: 'Clases restringidas actualizadas.', type: 'success' });
          })
          .catch(error => {
            const message = error.response?.data?.message || 'Error al actualizar las clases restringidas.';
            this.$notify({ group: 'foos', title: '¡Error!', text: message, type: 'error' });
          })
          .finally(() => {
            this.savingRestrictedClasses = false;
          });
      },

      saveAutoresponderClasses() {
        if (!this.profesional || !this.profesional.id) {
          this.$notify({ group: 'foos', title: 'Error', text: 'Profesional no encontrado.', type: 'error' });
          return;
        }

        this.savingAutoresponderClasses = true;
        axios.post(window.hostname + 'api/admin/profesional/autoresponder_clases', {
          profesional_id: this.profesional.id,
          clases: this.selectedAutoresponderClasses,
        })
          .then(response => {
            const newClases = response.data?.autoresponder_clases || [];
            this.profesional.autoresponder_clases = newClases;
            this.refreshAutoresponderClassSelection();
            this.$notify({ group: 'foos', title: 'Éxito', text: 'Clases de autoresponder actualizadas.', type: 'success' });
          })
          .catch(error => {
            const message = error.response?.data?.message || 'Error al actualizar las clases de autoresponder.';
            this.$notify({ group: 'foos', title: '¡Error!', text: message, type: 'error' });
          })
          .finally(() => {
            this.savingAutoresponderClasses = false;
          });
      },

      initialize_(set_loading = true) {
        if (typeof (this.$route.params.id) === 'number' || !isNaN(parseInt(this.$route.params.id))) {
          const profesionalId = parseInt(this.$route.params.id);
          if (set_loading) this.loaded = false;

          axios.post(window.hostname + 'api/admin/getprofesional', { id: profesionalId })
            .then(response => {
              this.profesional = response.data.profesional;
              this.bancos = response.data.bancos || {};
              this.tipos_de_cuenta = response.data.tipos_de_cuenta || {};
              this.syncEditForm();
              this.syncCompanyForm();
              this.syncBankForm();
              this.syncBheForm();
              this.refreshRestrictedClassSelection();
              this.refreshAutoresponderClassSelection();
              this.notificaciones = [];
              if (this.categorias && this.profesional.notificaciones) { // Ensure categorias is loaded
                for (var i = 0; i < this.categorias.length; i++) {
                  this.notificaciones.push({ id: this.categorias[i].id, nombre: this.categorias[i].nombre, active: this.profesional.notificaciones.some(x => x.categoria_id == this.categorias[i].id) })
                }
              }
              this.loaded = true;
  
              // Fetch data for new sections
              this.fetchLatestVisitas(profesionalId);
              this.fetchLatestRespuestas(profesionalId);
            })
            .catch(e => {
              this.loaded = true;
              this.$notify({ group: 'foos', title: '¡Error!', text: 'No se pudo cargar la información del profesional.', type: 'error' });
              console.error("Error al cargar profesional:", e);
            });
        } else {
          this.$notify({ group: 'foos', title: 'Error de Parámetro', text: 'ID de profesional inválido.', type: 'error' });
          this.loaded = true; // Stop loading state
        }
        if (!set_loading) {
          this.$forceUpdate();
        }
      },
  
      legacyFetchLatestVisitas(profesionalId) {
        this.loaded_visitas = false;
        // Placeholder: Replace with actual API call
        // Example: axios.post(window.hostname + `api/admin/profesional/${profesionalId}/ordenes`, { limit: 10, sort: 'desc' })
        // For now, let's assume 'ordenes' might be part of the professional object or needs a specific fetch.
        // If `this.profesional.solicitudes_asignadas` contains `ordenes`, you could derive it.
        // For demonstration, if `this.profesional.solicitudes_asignadas` exists and has `ordenes`:
        if (this.profesional && this.profesional.solicitudes_asignadas) {
            let allOrdenes = [];
            this.profesional.solicitudes_asignadas.forEach(solicitud => {
                if (solicitud.ordenes) {
                    solicitud.ordenes.forEach(orden => {
                        // Attach solicitud details to orden for easier display
                        orden.solicitud_cliente = { 
                            titulo: solicitud.titulo,
                            direccion: solicitud.direccion,
                            comuna: solicitud.comuna 
                        };
                         // Ensure fecha is usable by formatDate
                        if (orden.fecha && orden.fecha.a && orden.fecha.m && orden.fecha.d) {
                            orden.fecha_agendada = new Date(orden.fecha.a, orden.fecha.m - 1, orden.fecha.d);
                        } else if (!orden.fecha_agendada) {
                            orden.fecha_agendada = new Date(); // Fallback
                        }
                    });
                    allOrdenes = allOrdenes.concat(solicitud.ordenes);
                }
            });
            // Sort by date descending, take top 5 for example
            allOrdenes.sort((a, b) => new Date(b.fecha_agendada) - new Date(a.fecha_agendada));
            this.ordenes = allOrdenes.slice(0, 5);
        } else {
            // Fallback to an API call if data is not nested
            // This is a MOCK, replace with your actual API call
            console.warn("Fetching mock visitas as professional.solicitudes_asignadas is not structured as expected or API call needed.");
            // Simulating API response
            // this.ordenes = [{id: 1, solicitud_cliente: {titulo: "Visita Mock 1", direccion: "Direccion Mock 1", comuna: {nombre: "Comuna Mock"}}, fecha: {a:2023,m:1,d:10}, estado: 2}];
        }
  
        this.loaded_visitas = true;
        // .then(response => {
        //   this.ordenes = response.data.ordenes; // Assuming 'ordenes' is the array for visits
        //   this.loaded_visitas = true;
        // })
        // .catch(error => {
        //   console.error("Error fetching visitas:", error);
        //   this.loaded_visitas = true;
        //   this.$notify({ group: 'foos', title: 'Error', text: 'No se pudieron cargar las visitas.', type: 'error' });
        // });
      },
  
      legacyFetchLatestRespuestas(profesionalId) {
        this.loaded_respuestas = false;
        // Placeholder: Replace with actual API call
        // Example: axios.post(window.hostname + `api/admin/profesional/${profesionalId}/respuestas`, { limit: 5 })
        if (this.profesional && this.profesional.solicitudes_asignadas) {
          let allRespuestas = [];
          this.profesional.solicitudes_asignadas.forEach(solicitud => {
              if (solicitud.mensajes_profesional) {
                  solicitud.mensajes_profesional.forEach(mensaje => {
                      if (mensaje.profesional_id === this.profesional.id) { // Ensure it's from this professional
                          // Attach solicitud details to mensaje for easier display
                          mensaje.solicitud = { 
                              id: solicitud.id,
                              titulo: solicitud.titulo,
                              direccion: solicitud.direccion,
                              comuna: solicitud.comuna,
                              descripcion: solicitud.descripcion
                          };
                          allRespuestas.push(mensaje);
                      }
                  });
              }
          });
          allRespuestas.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
          this.latestRespuestas = allRespuestas.slice(0, 5); // Get latest 5
        } else {
            console.warn("Fetching mock respuestas as professional.solicitudes_asignadas is not structured as expected or API call needed.");
            // Example data used from data() section if API/nested data isn't available
        }
        this.loaded_respuestas = true;
        // .then(response => {
        //   this.latestRespuestas = response.data.respuestas;
        //   this.loaded_respuestas = true;
        // })
        // .catch(error => {
        //   console.error("Error fetching respuestas:", error);
        //   this.loaded_respuestas = true;
        //   this.$notify({ group: 'foos', title: 'Error', text: 'No se pudieron cargar las respuestas.', type: 'error' });
        // });
      },
      
      legacyFetchLatestPagos(profesionalId) {
        this.loaded_pagos = false;
        // Placeholder: Replace with actual API call
        // Example: axios.post(window.hostname + `api/admin/profesional/${profesionalId}/pagos`, { limit: 5 })
        if (this.profesional && this.profesional.solicitudes_asignadas) {
          let allPagos = [];
          this.profesional.solicitudes_asignadas.forEach(solicitud => {
              if (solicitud.ordenes) {
                  solicitud.ordenes.forEach(orden => {
                      // Assuming 'pagos' is a property on the 'orden' object from your API
                      // And 'Pago' model provided is what an item in 'orden.pagos' looks like
                      if (orden.pagos && Array.isArray(orden.pagos)) { // You might need to adjust this based on your actual data structure
                          orden.pagos.forEach(pago => {
                               allPagos.push({...pago, orden_id: orden.id }); // Add orden_id for context
                          });
                      }
                  });
              }
          });
          allPagos.sort((a, b) => new Date(b.fecha_pagado || b.fecha_creado) - new Date(a.fecha_pagado || a.fecha_creado));
          this.latestPagos = allPagos.slice(0,5);
        } else {
            console.warn("Fetching mock pagos as professional.solicitudes_asignadas is not structured as expected or API call needed.");
        }
        this.loaded_pagos = true;
        // .then(response => {
        //   this.latestPagos = response.data.pagos;
        //   this.loaded_pagos = true;
        // })
        // .catch(error => {
        //   console.error("Error fetching pagos:", error);
        //   this.loaded_pagos = true;
        //   this.$notify({ group: 'foos', title: 'Error', text: 'No se pudieron cargar los pagos.', type: 'error' });
        // });
      },
  
      legacyGetEstadoVisita(estado) {
        // Example, adjust to your 'orden.estado' meanings
        if (estado === 0) return 'Pendiente';
        if (estado === 1) return 'Confirmada';
        if (estado === 2) return 'Completada';
        if (estado === 3) return 'Cancelada';
        return 'Desconocido';
      },
  
      legacyGetEstadoPago(estado) {
        // Based on Pago model: estado = Column(Integer, default=0)
        if (estado === 0) return 'Pendiente';
        if (estado === 1) return 'Pagado';
        if (estado === 2) return 'Devuelto'; // Assuming 2 is for devolución
        return 'Desconocido';
      },
  
      legacyFormatDate(dateString) {
        if (!dateString) return 'N/A';
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString('es-ES', options);
      },
      fetchLatestVisitas() {
        this.loaded_visitas = false;
        const directOrders = this.profesional && Array.isArray(this.profesional.latest_ordenes)
          ? this.profesional.latest_ordenes
          : null;

        if (directOrders) {
          this.ordenes = directOrders
            .slice()
            .sort((a, b) => this.getTimestamp(this.getVisitDate(b) || b.fecha_creado) - this.getTimestamp(this.getVisitDate(a) || a.fecha_creado))
            .slice(0, 10);
          this.loaded_visitas = true;
          return;
        }

        const solicitudes = this.profesional && Array.isArray(this.profesional.solicitudes_asignadas)
          ? this.profesional.solicitudes_asignadas
          : [];
        const allOrdenes = [];

        solicitudes.forEach(solicitud => {
          const ordenes = Array.isArray(solicitud.ordenes) ? solicitud.ordenes : [];
          ordenes.forEach(orden => {
            allOrdenes.push({
              ...orden,
              solicitud_cliente: {
                id: solicitud.id,
                titulo: solicitud.titulo,
                direccion: solicitud.direccion,
                comuna: solicitud.comuna,
              },
            });
          });
        });

        allOrdenes.sort((a, b) => this.getTimestamp(this.getVisitDate(b)) - this.getTimestamp(this.getVisitDate(a)));
        this.ordenes = allOrdenes.slice(0, 10);
        this.loaded_visitas = true;
      },
      fetchLatestRespuestas() {
        this.loaded_respuestas = false;
        const combined = this.profesional && Array.isArray(this.profesional.latest_respuestas_combined)
          ? this.profesional.latest_respuestas_combined
          : null;

        if (combined) {
          this.latestRespuestas = combined
            .slice()
            .sort((a, b) => this.getTimestamp(b.fecha) - this.getTimestamp(a.fecha));
          this.loaded_respuestas = true;
          return;
        }

        const solicitudes = this.profesional && Array.isArray(this.profesional.solicitudes_asignadas)
          ? this.profesional.solicitudes_asignadas
          : [];
        const allRespuestas = [];

        solicitudes.forEach(solicitud => {
          const mensajes = Array.isArray(solicitud.mensajes_profesional) ? solicitud.mensajes_profesional : [];
          mensajes.forEach(mensaje => {
            if (String(mensaje.profesional_id) !== String(this.profesional.id)) return;
            allRespuestas.push({
              ...mensaje,
              solicitud: {
                id: solicitud.id,
                titulo: solicitud.titulo,
                direccion: solicitud.direccion,
                comuna: solicitud.comuna,
                descripcion: solicitud.descripcion,
              },
            });
          });
        });

        allRespuestas.sort((a, b) => this.getTimestamp(b.fecha) - this.getTimestamp(a.fecha));
        this.latestRespuestas = allRespuestas;
        this.loaded_respuestas = true;
      },
      fetchLatestPagos() {
        this.loaded_pagos = false;
        const directPayments = this.profesional && Array.isArray(this.profesional.latest_pagos)
          ? this.profesional.latest_pagos
          : null;

        if (directPayments) {
          this.latestPagos = directPayments
            .slice()
            .sort((a, b) => this.getTimestamp(b.fecha_pagado || b.fecha_creado) - this.getTimestamp(a.fecha_pagado || a.fecha_creado))
            .slice(0, 8);
          this.loaded_pagos = true;
          return;
        }

        const solicitudes = this.profesional && Array.isArray(this.profesional.solicitudes_asignadas)
          ? this.profesional.solicitudes_asignadas
          : [];
        const allPagos = [];

        solicitudes.forEach(solicitud => {
          const ordenes = Array.isArray(solicitud.ordenes) ? solicitud.ordenes : [];
          ordenes.forEach(orden => {
            const pagos = Array.isArray(orden.pagos) ? orden.pagos : [];
            pagos.forEach(pago => {
              allPagos.push({
                ...pago,
                orden_id: pago.orden_id || orden.id,
                solicitud: {
                  id: solicitud.id,
                  titulo: solicitud.titulo,
                },
              });
            });
          });
        });

        allPagos.sort((a, b) => this.getTimestamp(b.fecha_pagado || b.fecha_creado) - this.getTimestamp(a.fecha_pagado || a.fecha_creado));
        this.latestPagos = allPagos.slice(0, 6);
        this.loaded_pagos = true;
      },
      getEstadoVisita(estado) {
        const estados = {
          0: 'Pendiente',
          1: 'Agendado',
          2: 'Confirmado',
          3: 'En progreso',
          4: 'Atendido',
          10: 'Rechazado',
        };
        return estados[Number(estado)] || 'Desconocido';
      },
      getEstadoPago(estado) {
        const estados = {
          0: 'Pendiente',
          1: 'Pagado',
          2: 'Reversado',
          3: 'En revision',
        };
        return estados[Number(estado)] || 'Desconocido';
      },
      getOrderPayments(orden) {
        const pagos = orden && Array.isArray(orden.pagos) ? orden.pagos : [];
        return pagos
          .slice()
          .sort((a, b) => this.getTimestamp(b.fecha_pagado || b.fecha_creado) - this.getTimestamp(a.fecha_pagado || a.fecha_creado));
      },
      getOrderPaidTotal(orden) {
        return this.getOrderPayments(orden).reduce((total, pago) => {
          const isPaid = Number(pago.estado) === 1 || Boolean(pago.fecha_pagado);
          return isPaid ? total + (Number(pago.monto) || 0) : total;
        }, 0);
      },
      normalizeDateValue(value) {
        if (!value) return null;
        if (value instanceof Date) {
          return Number.isNaN(value.getTime()) ? null : value;
        }
        if (typeof value === 'object') {
          const year = value.a || value.y || value.year;
          const month = value.m || value.month;
          const day = value.d || value.day;
          if (year && month && day) {
            const dateFromParts = new Date(Number(year), Number(month) - 1, Number(day));
            return Number.isNaN(dateFromParts.getTime()) ? null : dateFromParts;
          }
        }
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? null : date;
      },
      getTimestamp(value) {
        const date = this.normalizeDateValue(value);
        return date ? date.getTime() : 0;
      },
      formatDate(value) {
        const date = this.normalizeDateValue(value);
        if (!date) return 'Sin fecha';
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return date.toLocaleDateString('es-CL', options);
      },
      formatCurrency(value) {
        const amount = Number(value || 0);
        return `$${amount.toLocaleString('es-CL')}`;
      },
      formatPoints(value) {
        const points = Number(value || 0);
        return points.toLocaleString('es-CL');
      },
      getJobbingPointsPurchaseAddress(purchase) {
        if (!purchase) return 'Sin direccion asociada';
        const comuna = purchase.comuna && purchase.comuna.nombre ? purchase.comuna.nombre : '';
        const parts = [purchase.direccion, comuna].filter(Boolean);
        return parts.length ? parts.join(', ') : 'Sin direccion asociada';
      },
      purchaseRefundKey(purchase) {
        return purchase && purchase.solicitud_id ? String(purchase.solicitud_id) : '';
      },
      isRefundingPurchase(purchase) {
        const key = this.purchaseRefundKey(purchase);
        return Boolean(key && this.jobbingPointsRefunding[key]);
      },
      contactReportStatusLabel(report) {
        if (!report) return 'Sin reporte';
        const labels = {
          pendiente: 'pendiente',
          aprobado: 'aprobado',
          rechazado: 'rechazado',
          resuelto: 'resuelto',
        };
        return labels[report.estado] || report.estado || 'recibido';
      },
      markJobbingPointsPurchaseRefunded(solicitudId, updatedPurchase) {
        const purchases = Array.isArray(this.profesional.jobbing_points_request_purchases)
          ? this.profesional.jobbing_points_request_purchases
          : [];
        const index = purchases.findIndex(purchase => String(purchase.solicitud_id) === String(solicitudId));
        if (index === -1) {
          return;
        }

        const current = purchases[index];
        const next = {
          ...current,
          ...(updatedPurchase || {}),
          restituida: true,
          puntos_restituidos: updatedPurchase?.puntos_restituidos || current.puntos_jobbing_gastados,
          fecha_restitucion: updatedPurchase?.fecha_restitucion || new Date().toISOString(),
        };
        this.$set(this.profesional.jobbing_points_request_purchases, index, next);
      },
      refundJobbingPointsRequestPurchase(purchase) {
        if (!purchase || purchase.restituida || this.isRefundingPurchase(purchase)) {
          return;
        }

        const pointsLabel = this.formatPoints(purchase.puntos_jobbing_gastados);
        const solicitudLabel = purchase.solicitud_titulo || `Solicitud #${purchase.solicitud_id}`;
        if (!confirm(`Restituir ${pointsLabel} puntos por ${solicitudLabel}?`)) {
          return;
        }

        const motivo = window.prompt('Motivo de restitucion', '');
        if (motivo === null) {
          return;
        }

        const key = this.purchaseRefundKey(purchase);
        this.$set(this.jobbingPointsRefunding, key, true);
        axios.post(window.hostname + 'api/admin/profesional/jobbing_points/refund_request_purchase', {
          profesional_id: this.profesional.id,
          solicitud_id: purchase.solicitud_id,
          motivo,
        })
          .then(response => {
            const newBalance = Number(response.data?.balance);
            if (Number.isFinite(newBalance)) {
              this.$set(this.profesional, 'jobbing_points_balance', newBalance);
            }
            this.markJobbingPointsPurchaseRefunded(purchase.solicitud_id, response.data?.purchase || {});
            this.$notify({
              group: 'foos',
              title: 'Puntos restituidos',
              text: `${pointsLabel} puntos fueron restituidos al profesional.`,
              type: 'success',
            });
          })
          .catch(error => {
            if (error.response?.data?.already_refunded) {
              this.markJobbingPointsPurchaseRefunded(purchase.solicitud_id, error.response.data.purchase || {});
            }
            const message = error.response?.data?.message || 'No se pudo restituir la compra con puntos.';
            this.$notify({ group: 'foos', title: 'Error', text: message, type: 'error' });
          })
          .finally(() => {
            this.$delete(this.jobbingPointsRefunding, key);
          });
      },
      getVisitDate(visita) {
        if (!visita) return null;
        return visita.fecha_agendada || visita.fecha_ || visita.fecha;
      },
      getVisitTime(visita) {
        if (!visita || visita.desde === undefined || visita.desde === null) return '';
        return this.timeConvert(visita.desde);
      },
      getVisitTitle(visita) {
        const solicitud = visita && visita.solicitud_cliente ? visita.solicitud_cliente : {};
        return solicitud.titulo || `Orden #${visita && visita.id ? visita.id : ''}`.trim() || 'Visita programada';
      },
      getVisitSolicitudId(visita) {
        if (!visita) return null;
        const solicitud = visita.solicitud_cliente || visita.solicitud || {};
        return solicitud.id || visita.solicitud_cliente_id || visita.solicitud_id || null;
      },
      getVisitAddress(visita) {
        const solicitud = visita && visita.solicitud_cliente ? visita.solicitud_cliente : {};
        const comuna = solicitud.comuna && solicitud.comuna.nombre ? solicitud.comuna.nombre : '';
        const ordenComuna = visita && visita.comuna && visita.comuna.nombre ? visita.comuna.nombre : '';
        const parts = [solicitud.direccion || (visita && visita.direccion), comuna || ordenComuna].filter(Boolean);
        return parts.length ? parts.join(', ') : 'Direccion no informada';
      },
      getSolicitudDetallePath(solicitudId) {
        return `/SolicitudDetalleAdmin/${solicitudId}`;
      },
      getResponseRequestTitle(respuesta) {
        const solicitud = respuesta && respuesta.solicitud ? respuesta.solicitud : {};
        return solicitud.titulo || `Solicitud #${solicitud.id || ''}`.trim() || 'Solicitud';
      },
      getResponseSolicitudId(respuesta) {
        if (!respuesta) return null;
        const solicitud = respuesta.solicitud || {};
        return solicitud.id || respuesta.solicitud_id || respuesta.solicitud_cliente_id || null;
      },
      getResponseRequestAddress(respuesta) {
        const solicitud = respuesta && respuesta.solicitud ? respuesta.solicitud : {};
        const comuna = solicitud.comuna && solicitud.comuna.nombre ? solicitud.comuna.nombre : '';
        const parts = [solicitud.direccion, comuna].filter(Boolean);
        return parts.length ? parts.join(', ') : 'Sin direccion asociada';
      },
      getPagoSolicitudId(pago) {
        if (!pago) return null;
        const solicitud = pago.solicitud || pago.solicitud_cliente || {};
        return solicitud.id || pago.solicitud_id || pago.solicitud_cliente_id || null;
      },
      getPagoSolicitudLabel(pago) {
        const solicitud = pago && (pago.solicitud || pago.solicitud_cliente) ? (pago.solicitud || pago.solicitud_cliente) : {};
        const solicitudId = this.getPagoSolicitudId(pago);
        return solicitud.titulo || (solicitudId ? `Solicitud #${solicitudId}` : 'Solicitud');
      },
      normalizeChatMessages(messages) {
        const list = Array.isArray(messages) ? messages : [];
        return list
          .map(message => ({
            ...message,
            fecha: message.fecha || message.fecha_iso || null,
            sender_type: message.sender_type || message.sender || '',
            mensaje: message.mensaje || message.texto || 'Mensaje sin texto',
          }))
          .sort((a, b) => this.getTimestamp(a.fecha) - this.getTimestamp(b.fecha));
      },
      messageSenderLabel(message) {
        const labels = {
          cliente: 'Cliente',
          admin_propiedad: 'Admin. propiedad',
          profesional: 'Profesional',
          administrador: 'Administrador',
        };
        return labels[message && message.sender_type] || message?.sender_label || 'Sistema';
      },
      messagePreviewClass(message) {
        const senderType = message && message.sender_type;
        if (senderType === 'profesional') return 'from-professional';
        if (senderType === 'cliente' || senderType === 'admin_propiedad') return 'from-client';
        return 'from-system';
      },
      isAnsweredRequestExpanded(solicitudId) {
        return Boolean(this.expandedAnsweredRequests[solicitudId]);
      },
      toggleAnsweredRequest(solicitudId) {
        this.$set(this.expandedAnsweredRequests, solicitudId, !this.isAnsweredRequestExpanded(solicitudId));
      },
      chatToggleLabel(solicitud) {
        const count = solicitud && Array.isArray(solicitud.mensajes_chat) ? solicitud.mensajes_chat.length : 0;
        return this.isAnsweredRequestExpanded(solicitud.id)
          ? 'Ocultar chat'
          : `Ver chat (${count})`;
      },
      truncateText(value, maxLength) {
        const text = value ? String(value).trim() : '';
        if (!text) return 'Sin mensaje';
        if (text.length <= maxLength) return text;
        return `${text.slice(0, maxLength - 1)}...`;
      },
      
      timeConvert(n) { // Kept if needed for visit times, etc.
        if (isNaN(n) || n === null) return 'N/A';
        var num = n;
        var hours = (num / 60);
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);
        return (rhours < 10 ? '0' : '') + rhours + ":" + (rminutes < 10 ? '0' : '') + rminutes + "";
      },
  
      // ... (keep existing methods like toggleOcultar, toggleRestricted, toggleSuspendir, eliminarArchivo, descargarArchivo, cambiar_autorespuesta, guardar_informacion, actualizar_notificaciones, actualizar_password_profesional)
      // Make sure these methods are still relevant and don't rely on removed data.
      // For example, if a method was specific to "Horarios" or "Bloqueos", it should be removed.
  
      // --- Existing methods from original component (review and keep if necessary) ---
      toggleOcultar() {
        const action = this.profesional.oculto ? 'desocultar' : 'ocultar';
        const endpoint = window.hostname + `api/admin/${action}_profesional`;
        const data = { profesional_id: this.profesional.id };
        const confirmationMessage = this.profesional.oculto ? '¿Estás seguro de que deseas mostrar este profesional?' : '¿Estás seguro de que deseas ocultar este profesional?';
        if (!confirm(confirmationMessage)) return;
        axios.post(endpoint, data)
          .then(() => {
            this.profesional.oculto = !this.profesional.oculto;
            this.$notify({ group: 'foos', title: 'Éxito', text: `Profesional ${this.profesional.oculto ? 'ocultado' : 'mostrado'}.`, type: 'success' });
          })
          .catch(error => {
            this.$notify({ group: 'foos', title: '¡Error!', text: error.response?.data?.message || 'Error al actualizar visibilidad.', type: 'error' });
          });
      },
      togglePrivadas() {
        const action = this.profesional.solicitudes_privadas ? 'desocultar' : 'ocultar';
        const endpoint = window.hostname + `api/admin/${action}_profesional`;
        const data = { profesional_id: this.profesional.id };
        const confirmationMessage = !this.profesional.solicitudes_privadas ? '¿Estás seguro de que deseas mostrar este profesional?' : '¿Estás seguro de que deseas ocultar este profesional?';
        if (!confirm(confirmationMessage)) return;
        axios.post(endpoint, data)
          .then(() => {
            this.profesional.solicitudes_privadas = !this.profesional.solicitudes_privadas;
            this.$notify({ group: 'foos', title: 'Éxito', text: `Profesional ${this.profesional.solicitudes_privadas ? 'desactivar' : 'activar'}.`, type: 'success' });
          })
          .catch(error => {
            this.$notify({ group: 'foos', title: '¡Error!', text: error.response?.data?.message || 'Error al actualizar visibilidad.', type: 'error' });
          });
      },
      toggleSoloCompraSolicitudes() {
        const soloCompraSolicitudes = !this.profesional.solo_compra_solicitudes;
        const confirmationMessage = soloCompraSolicitudes
          ? '¿Activar modo solo compra de solicitudes?'
          : '¿Desactivar modo solo compra de solicitudes?';
        if (!confirm(confirmationMessage)) return;

        axios.post(window.hostname + 'api/admin/profesional/solo_compra_solicitudes', {
          profesional_id: this.profesional.id,
          solo_compra_solicitudes: soloCompraSolicitudes,
        })
          .then((response) => {
            const newValue = response.data?.solo_compra_solicitudes;
            this.$set(this.profesional, 'solo_compra_solicitudes', typeof newValue === 'boolean' ? newValue : soloCompraSolicitudes);
            this.$notify({
              group: 'foos',
              title: 'Éxito',
              text: `Solo compra de solicitudes ${this.profesional.solo_compra_solicitudes ? 'activado' : 'desactivado'}.`,
              type: 'success',
            });
          })
          .catch(error => {
            this.$notify({ group: 'foos', title: '¡Error!', text: error.response?.data?.message || 'Error al actualizar solo compra de solicitudes.', type: 'error' });
          });
      },
      toggleRestricted() {
        const action = this.profesional.visibilidad_restringida ? 'desrestringir_visibilidad' : 'restringir_visibilidad';
        const endpoint = window.hostname + `api/admin/${action}_profesional`;
        const data = { profesional_id: this.profesional.id };
        const confirmationMessage = this.profesional.visibilidad_restringida ? '¿Desactivar visibilidad restringida?' : '¿Activar visibilidad restringida?';
        if (!confirm(confirmationMessage)) return;
        axios.post(endpoint, data)
          .then(() => {
            this.profesional.visibilidad_restringida = !this.profesional.visibilidad_restringida;
            this.$notify({ group: 'foos', title: 'Éxito', text: `Visibilidad restringida ${this.profesional.visibilidad_restringida ? 'activada' : 'desactivada'}.`, type: 'success' });
          })
          .catch(error => {
            this.$notify({ group: 'foos', title: '¡Error!', text: error.response?.data?.message || 'Error al actualizar restricción.', type: 'error' });
          });
      },
      toggleRestrictedManual() {
        const action = this.profesional.visibilidad_restringida_manual ? 'desrestringir_visibilidad_manual' : 'restringir_visibilidad_manual';
        const endpoint = window.hostname + `api/admin/${action}`;
        const data = { profesional_id: this.profesional.id };
        const confirmationMessage = this.profesional.visibilidad_restringida_manual ? '¿Desactivar restricción manual?' : '¿Activar restricción manual?';
        if (!confirm(confirmationMessage)) return;
        axios.post(endpoint, data)
          .then(() => {
            this.profesional.visibilidad_restringida_manual = !this.profesional.visibilidad_restringida_manual;
            this.$notify({ group: 'foos', title: 'Éxito', text: `Restricción manual ${this.profesional.visibilidad_restringida_manual ? 'activada' : 'desactivada'}.`, type: 'success' });
          })
          .catch(error => {
            this.$notify({ group: 'foos', title: '¡Error!', text: error.response?.data?.message || 'Error al actualizar restricción.', type: 'error' });
          });
      },
      toggleSuspendir() {
        const action = this.profesional.suspendido ? 'unsuspend' : 'suspend';
        const endpoint = window.hostname + `api/admin/${action}_profesional`;
        const data = { profesional_id: this.profesional.id };
        const confirmationMessage = this.profesional.suspendido ? '¿Desactivar suspensión?' : '¿Suspender profesional?';
        if (!confirm(confirmationMessage)) return;
        axios.post(endpoint, data)
          .then(() => {
            this.profesional.suspendido = !this.profesional.suspendido;
            this.$notify({ group: 'foos', title: 'Éxito', text: `Profesional ${this.profesional.suspendido ? 'suspendido' : 'activado'}.`, type: 'success' });
          })
          .catch(error => {
            this.$notify({ group: 'foos', title: '¡Error!', text: error.response?.data?.message || 'Error al actualizar suspensión.', type: 'error' });
          });
      },
      clearContactModerationSuspension() {
        if (!this.profesional || !this.profesional.id || this.clearingContactModeration) {
          return;
        }
        const confirmationMessage = '¿Levantar la suspensión de moderación de contacto y reiniciar sus strikes?';
        if (!confirm(confirmationMessage)) return;

        this.clearingContactModeration = true;
        axios.post(window.hostname + 'api/admin/profesional/clear_contact_moderation', {
          profesional_id: this.profesional.id,
        })
          .then((response) => {
            const data = response.data || {};
            this.$set(this.profesional, 'contact_moderation_strikes', data.contact_moderation_strikes || 0);
            this.$set(this.profesional, 'contact_moderation_suspended_until', data.contact_moderation_suspended_until || null);
            this.$set(this.profesional, 'contact_moderation_permanent', Boolean(data.contact_moderation_permanent));
            this.$set(this.profesional, 'contact_moderation_last_action', data.contact_moderation_last_action || 'admin_cleared_contact_moderation');
            this.$set(this.profesional, 'contact_moderation_last_violation_at', data.contact_moderation_last_violation_at || null);
            this.$set(this.profesional, 'contact_moderation_active', false);
            if (Object.prototype.hasOwnProperty.call(data, 'suspendido')) {
              this.$set(this.profesional, 'suspendido', data.suspendido);
            }
            this.$notify({
              group: 'foos',
              title: 'Éxito',
              text: data.message || 'Suspensión de moderación levantada.',
              type: 'success',
            });
          })
          .catch(error => {
            this.$notify({
              group: 'foos',
              title: '¡Error!',
              text: error.response?.data?.message || 'Error al levantar la suspensión de moderación.',
              type: 'error',
            });
          })
          .finally(() => {
            this.clearingContactModeration = false;
          });
      },
      eliminarArchivo(aid) {
        if (confirm('¿Estás seguro de que deseas eliminar este archivo?')) {
          axios.post(window.hostname + 'api/superadmin/profesional_eliminar_archivo', { archivo_id: aid })
            .then(() => {
              this.$notify({ group: 'foos', title: 'Archivo eliminado', text: '¡Se ha eliminado el archivo!', type: 'success' });
              this.initialize_(false); 
            })
            .catch(e => {
              this.$notify({ group: 'foos', title: '¡Error!', text: e.response?.data?.message || 'Error al eliminar.', type: 'error' });
            });
        }
      },
      descargarArchivo(archivo) {
        axios({ url: window.hostname + 'api/superadmin/obtener_link_archivo_profesional', method: 'POST', data: { archivo_id: archivo.id } })
          .then((response) => {
            const anchor = document.createElement('a');
            anchor.href = response.data.link;
            anchor.download = archivo.nombre + '.' + response.data.ext;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
          })
          .catch(e => console.error(e));
      },
      cambiar_autorespuesta(pid) { // pid is profesional_id
        axios.post(window.hostname + 'api/superadmin/cambiar_autorespuesta', { profesional_id: pid })
          .then(() => {
            this.$notify({ group: 'foos', title: 'Actualizado', text: '¡Se ha actualizado la autorespuesta!', type: 'success' });
            this.initialize_(false);
          })
          .catch(e => this.$notify({ group: 'foos', title: '¡Error!', text: e.response?.data?.message || 'Error.', type: 'error' }));
      },
      cambiar_idle_followup(pid, enabled) {
        axios.post(window.hostname + 'api/superadmin/cambiar_idle_followup', { profesional_id: pid, enabled })
          .then((response) => {
            const newValue = response.data?.idle_followup_enabled;
            if (typeof newValue === 'boolean') {
              this.$set(this.profesional, 'idle_followup_enabled', newValue);
            } else {
              this.profesional.idle_followup_enabled = !this.profesional.idle_followup_enabled;
            }
            this.$notify({ group: 'foos', title: 'Actualizado', text: 'Recordatorios actualizados', type: 'success' });
          })
          .catch(e => this.$notify({ group: 'foos', title: '¡Error!', text: e.response?.data?.message || 'Error.', type: 'error' }));
      },
      actualizar_configuracion_ai(pid, mostrar) {
        axios.post(window.hostname + 'api/superadmin/actualizar_mostrar_configuracion_ai', { profesional_id: pid, mostrar })
          .then((response) => {
            const newValue = response.data?.mostrar_configuracion_ai;
            if (typeof newValue === 'boolean') {
              this.$set(this.profesional, 'mostrar_configuracion_ai', newValue);
            } else {
              this.profesional.mostrar_configuracion_ai = !this.profesional.mostrar_configuracion_ai;
            }
            this.$notify({ group: 'foos', title: 'Actualizado', text: 'Configuración IA actualizada', type: 'success' });
          })
          .catch(e => this.$notify({ group: 'foos', title: '¡Error!', text: e.response?.data?.message || 'Error.', type: 'error' }));
      },
      guardar_informacion(pid) {
        axios.post(window.hostname + 'api/superadmin/guardar_informacion_escondida', { profesional_id: pid, informacion: this.profesional.informacion_escondida })
          .then(() => {
            this.$notify({ group: 'foos', title: 'Actualizado', text: '¡Información guardada!', type: 'success' });
            // No need to re-initialize if only this field changed and is bound by v-model
          })
          .catch(e => this.$notify({ group: 'foos', title: '¡Error!', text: e.response?.data?.message || 'Error.', type: 'error' }));
      },
      async toggleEmailNotifications() {
        if (this.savingEmailNotifications) return;
        this.savingEmailNotifications = true;
        try {
          const response = await axios.post(window.hostname + 'api/admin/profesional/notificaciones_email', {
            profesional_id: this.profesional.id,
            notificaciones_email: !this.profesional.notificaciones_email,
          });
          this.profesional.notificaciones_email = response.data.notificaciones_email;
          this.$notify({
            group: 'foos',
            title: 'Notificaciones por email',
            text: this.profesional.notificaciones_email ? 'Notificaciones por email activadas.' : 'Notificaciones por email desactivadas.',
            type: 'success',
          });
        } catch (error) {
          this.$notify({ group: 'foos', title: '¡Error!', text: error.response?.data?.message || 'No se pudieron actualizar las notificaciones por email.', type: 'error' });
        } finally {
          this.savingEmailNotifications = false;
        }
      },
      actualizar_notificaciones() {
        let cats = this.notificaciones.filter(c => c.active).map(c => ({ categoria_id: c.id }));
        axios.post(window.hostname + 'api/admin/modificar_config_notificaciones', { id: this.profesional.id, categorias: cats })
          .then(() => {
            this.$notify({ group: 'foos', title: 'Notificaciones actualizadas', type: 'success' });
            // No need to re-initialize if local state is source of truth or backend confirms changes
          })
          .catch(e => this.$notify({ group: 'foos', title: '¡Error!', text: e.response?.data?.message || 'Error.', type: 'error' }));
      },
      actualizar_password_profesional() {
        axios.post(window.hostname + 'api/admin/establecer_password_profesional', { profesional_id: this.profesional.id })
          .then(() => {
            this.$notify({ group: 'foos', title: 'Contraseña Actualizada', type: 'success' });
          })
          .catch(error => this.$notify({ group: 'foos', title: '¡Error!', text: error.response?.data?.message || 'Error.', type: 'error' }));
      }
  
    },
    computed: {
      ...mapGetters(['comunas', 'categorias', 'regiones', 'prestaciones', 'tipos', 'admin_datos']),
      jobbingPointsRequestPurchases() {
        const purchases = this.profesional && Array.isArray(this.profesional.jobbing_points_request_purchases)
          ? this.profesional.jobbing_points_request_purchases
          : [];
        return purchases
          .slice()
          .sort((a, b) => this.getTimestamp(b.fecha_compra_puntos) - this.getTimestamp(a.fecha_compra_puntos));
      },
      hasContactModerationSanction() {
        const profesional = this.profesional || {};
        return Boolean(
          Number(profesional.contact_moderation_strikes || 0) > 0 ||
          profesional.contact_moderation_suspended_until ||
          profesional.contact_moderation_permanent ||
          profesional.contact_moderation_active
        );
      },
      contactModerationSummary() {
        const profesional = this.profesional || {};
        const strikes = Number(profesional.contact_moderation_strikes || 0);
        if (profesional.contact_moderation_permanent) {
          return `suspensión permanente activa (${strikes} strike${strikes === 1 ? '' : 's'}).`;
        }
        if (profesional.contact_moderation_suspended_until) {
          return `suspensión temporal hasta ${this.formatDateTime(profesional.contact_moderation_suspended_until)} (${strikes} strike${strikes === 1 ? '' : 's'}).`;
        }
        if (strikes > 0) {
          return `${strikes} strike${strikes === 1 ? '' : 's'} acumulado${strikes === 1 ? '' : 's'}, sin suspensión activa.`;
        }
        return 'sin sanción activa.';
      },
      latestSolicitudesContestadas() {
        const directRequests = this.profesional && Array.isArray(this.profesional.latest_solicitudes_contestadas)
          ? this.profesional.latest_solicitudes_contestadas
          : null;

        if (directRequests) {
          return directRequests
            .map(solicitud => ({
              id: solicitud.id,
              titulo: solicitud.titulo || `Solicitud #${solicitud.id}`,
              direccion: [
                solicitud.direccion,
                solicitud.comuna && solicitud.comuna.nombre ? solicitud.comuna.nombre : '',
              ].filter(Boolean).join(', ') || 'Sin direccion asociada',
              is_public_solicitud: Boolean(solicitud.is_public_solicitud),
              ultima_respuesta_fecha: solicitud.ultima_respuesta_fecha,
              mensajes_chat: this.normalizeChatMessages(solicitud.mensajes_chat),
            }))
            .sort((a, b) => this.getTimestamp(b.ultima_respuesta_fecha) - this.getTimestamp(a.ultima_respuesta_fecha))
            .slice(0, 10);
        }

        const grouped = new Map();
        this.latestRespuestas.forEach(respuesta => {
          const solicitud = respuesta && respuesta.solicitud ? respuesta.solicitud : {};
          const solicitudId = this.getResponseSolicitudId(respuesta);
          if (!solicitudId) return;

          if (!grouped.has(solicitudId)) {
            grouped.set(solicitudId, {
              id: solicitudId,
              titulo: solicitud.titulo || `Solicitud #${solicitudId}`,
              direccion: this.getResponseRequestAddress(respuesta),
              is_public_solicitud: Boolean(respuesta.is_public_solicitud),
              ultima_respuesta_fecha: respuesta.fecha,
              mensajes_chat: [],
            });
          }

          const item = grouped.get(solicitudId);
          if (this.getTimestamp(respuesta.fecha) > this.getTimestamp(item.ultima_respuesta_fecha)) {
            item.ultima_respuesta_fecha = respuesta.fecha;
          }
          item.is_public_solicitud = item.is_public_solicitud || Boolean(respuesta.is_public_solicitud);

          const chatMessages = this.normalizeChatMessages(solicitud.mensajes_chat);
          if (chatMessages.length > item.mensajes_chat.length) {
            item.mensajes_chat = chatMessages;
          }
          if (!item.mensajes_chat.some(message => message.id === respuesta.id && message.sender_type === 'profesional')) {
            item.mensajes_chat.push({
              id: respuesta.id,
              mensaje: respuesta.mensaje,
              fecha: respuesta.fecha,
              sender_type: 'profesional',
              sender_label: 'Profesional',
            });
          }
          item.mensajes_chat = this.normalizeChatMessages(item.mensajes_chat);
        });

        return Array.from(grouped.values())
          .sort((a, b) => this.getTimestamp(b.ultima_respuesta_fecha) - this.getTimestamp(a.ultima_respuesta_fecha))
          .slice(0, 10);
      },
      // Removed horaMin, horaMax, viendoSemana
    },
    mounted() {
      // Fuse related logic can be removed if fComunas is no longer used.
      // this.fComunas = new Fuse(this.comunas, {  keys: ['Nombre']}) 
      this.$root.$on('update-profesionales', () => {
        this.initialize_(false)
      });
    },
    watch: {
      // Remove 'comunas_buscadas' watcher if not used
      // comunas_buscadas(val){
      //   this.resultado_fuse_comuna = this.fComunas.search(val)
      // },
      '$route.params.id': function() { // Re-initialize if route id changes
          this.initialize_();
      }
    }
  }
  </script>
  
  <style scoped>
  .btn-std {
    background-color: #007bff !important;
    color: white !important;
    border: none;
  }
  .btn-std:hover {
    background-color: #0056b3 !important;
  }
  .confirm-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1200;
    padding: 1rem;
  }
  .confirm-modal {
    background: #fff;
    border-radius: 12px;
    padding: 1.25rem;
    width: 100%;
    max-width: 460px;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
  }
  .confirm-actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: 1rem;
  }
  .confirm-cancel-btn,
  .confirm-ok-btn {
    border: none;
    border-radius: 8px;
    padding: 0.5rem 0.9rem;
    font-weight: 600;
    cursor: pointer;
  }
  .confirm-cancel-btn {
    background: #e9ecef;
    color: #212529;
  }
  .confirm-ok-btn {
    background: #dc3545;
    color: #fff;
  }
  .confirm-cancel-btn:disabled,
  .confirm-ok-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  .eliminar-btn {
    background-color: #e74c3c;
    color: white;
    border: none;
    padding: 0.375rem 0.75rem; /* Match btn-sm */
    border-radius: 0.2rem; /* Match btn-sm */
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  .eliminar-btn:hover {
    background-color: #c0392b;
  }
  .star {
    cursor: pointer;
    margin-right: 4px;
    height: 18px;
    width: 18px;
    color: #DAA520;
  }
  h2 {
    font-weight: 600; /* Slightly less bold */
    font-size: 1.5rem; /* Slightly smaller */
    margin-bottom: 1rem; /* Reduced margin */
    color: #333;
  }
  .sectionv {
    background-color: #f8f9fa; /* Lighter background */
    border-radius: 8px; /* Softer radius */
    padding: 1.25rem; /* 20px */
    margin-bottom: 1.25rem; /* 20px */
    border: 1px solid #e9ecef; /* Subtle border */
  }
  .restricted-helper-text {
    color: #6c757d;
    margin-bottom: 0.75rem;
  }
  .section-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;
  }
  .section-header h2 {
    margin-bottom: 0.25rem;
  }
  .section-subtitle {
    color: #6c757d;
    margin: 0;
  }
  .bank-status,
  .activity-count,
  .points-balance {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    padding: 0.35rem 0.65rem;
    font-size: 0.82rem;
    font-weight: 700;
    white-space: nowrap;
  }
  .bank-status-ready {
    background: #e6f4ea;
    color: #1f7a3d;
  }
  .bank-status-missing {
    background: #fff3cd;
    color: #8a5b00;
  }
  .bank-summary {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
    gap: 0.6rem 1rem;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 0.9rem;
    margin-bottom: 1rem;
  }
  .bank-form-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
    gap: 0.9rem 1rem;
  }
  .bank-account-field {
    grid-column: 1 / -1;
  }
  .activity-count {
    min-width: 2.25rem;
    background: #e8f0fe;
    color: #1a5bb8;
  }
  .points-balance {
    background: #edf7ee;
    color: #1f7a3d;
  }
  .activity-list {
    display: grid;
    gap: 0.75rem;
  }
  .activity-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 1rem;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 0.95rem;
  }
  .activity-main {
    min-width: 0;
    flex: 1;
  }
  .activity-title {
    font-weight: 700;
    color: #212529;
    overflow-wrap: anywhere;
  }
  .activity-link {
    color: #0369a1;
    text-decoration: none;
  }
  .activity-meta {
    color: #6c757d;
    font-size: 0.88rem;
    margin-top: 0.2rem;
  }
  .activity-detail {
    color: #495057;
    margin-top: 0.45rem;
    overflow-wrap: anywhere;
  }
  .activity-quote {
    margin-top: 0.45rem;
    color: #343a40;
    font-style: italic;
    white-space: pre-line;
    overflow-wrap: anywhere;
  }
  .activity-status {
    flex: 0 0 auto;
    border-radius: 8px;
    padding: 0.3rem 0.55rem;
    background: #f1f3f5;
    color: #495057;
    font-size: 0.78rem;
    font-weight: 700;
    text-align: center;
  }
  .activity-side {
    flex: 0 0 auto;
    min-width: 120px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.15rem;
    text-align: right;
  }
  .activity-side strong {
    color: #1f7a3d;
    font-size: 1rem;
  }
  .activity-side span,
  .activity-side small {
    color: #6c757d;
    font-size: 0.78rem;
    font-weight: 700;
  }
  .payment-chip-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.4rem;
    margin-top: 0.55rem;
  }
  .payment-chip {
    border-radius: 999px;
    background: #eaf7ef;
    color: #20744a;
    font-size: 0.78rem;
    font-weight: 700;
    padding: 0.25rem 0.55rem;
  }
  .points-purchase-side {
    min-width: 150px;
  }
  .refund-points-btn {
    margin-top: 0.45rem;
    border: 1px solid #c7d2fe;
    background: #eef2ff;
    color: #3730a3;
    font-weight: 800;
  }
  .refund-points-btn:hover:not(:disabled) {
    background: #e0e7ff;
  }
  .refund-points-btn:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }
  .refund-note {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 0.2rem;
    margin-top: 0.55rem;
    border-radius: 8px;
    background: #eaf7ef;
    color: #20744a;
    font-size: 0.82rem;
    font-weight: 800;
    padding: 0.3rem 0.55rem;
  }
  .contact-report-note {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 0.2rem;
    margin-top: 0.45rem;
    border-radius: 8px;
    background: #fff7ed;
    color: #9a3412;
    font-size: 0.82rem;
    font-weight: 800;
    padding: 0.3rem 0.55rem;
  }
  .activity-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 32px;
    border: 1px solid #dbe3ef;
    border-radius: 8px;
    background: #fff;
    color: #0369a1;
    font-size: 0.82rem;
    font-weight: 800;
    padding: 0 0.7rem;
    margin-top: 0.65rem;
    cursor: pointer;
  }
  .chat-preview {
    display: grid;
    gap: 0.45rem;
    margin-top: 0.75rem;
  }
  .chat-preview-message {
    width: min(100%, 720px);
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 0.55rem 0.65rem;
    background: #fff;
  }
  .chat-preview-message.from-professional {
    margin-left: auto;
    background: #eef2ff;
    border-color: #c7d2fe;
  }
  .chat-preview-message.from-client {
    background: #f8fafc;
    border-color: #cbd5e1;
  }
  .chat-preview-message span {
    display: block;
    color: #212529;
    font-size: 0.74rem;
    font-weight: 800;
    text-transform: uppercase;
  }
  .chat-preview-message p {
    margin: 0.15rem 0 0;
    color: #343a40;
    font-size: 0.88rem;
    line-height: 1.4;
    white-space: pre-line;
  }
  .chat-preview-message small {
    display: block;
    margin-top: 0.2rem;
    color: #6c757d;
    font-size: 0.74rem;
  }
  .empty-state {
    margin: 0;
    color: #6c757d;
    font-style: italic;
  }
  .bhe-status-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 0.75rem 1rem;
  }
  .restricted-class-options {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem 1rem;
  }
  .restricted-class-option {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 500;
  }
  .restricted-class-selected {
    margin-top: 0.75rem;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .badge-restricted {
    background-color: #6c5ce7;
    color: #fff;
    padding: 0.35rem 0.6rem;
    border-radius: 999px;
    font-size: 0.85rem;
  }
  .restricted-class-empty {
    font-style: italic;
    color: #6c757d;
    margin-top: 0.75rem;
  }
  .styled-textarea {
    display: block;
    width: 100%;
    max-width: 600px;
    height: 150px; /* Reduced height */
    padding: 10px;
    border: 1px solid #ced4da; /* Standard bootstrap border */
    border-radius: .25rem;
    font-size: 1rem;
    line-height: 1.5;
    background-color: #fff;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    resize: vertical;
  }
  .styled-textarea:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 .2rem rgba(0,123,255,.25);
    outline: none;
  }
  .btn-activacion {
    display: inline-block;
    border-radius: 5px;
    padding: 5px 15px;
    color: #fff;
    cursor: pointer;
    margin-top: 5px;
    font-weight: 500;
  }
  .btn-activado {
    background-color: #dc3545; /* Bootstrap danger */
  }
  .btn-desactivado {
    background-color: #28a745; /* Bootstrap success */
  }
  td {
    text-align: left;
  }
  .column-right {
    background-color: #eef2f7; /* Slightly different background */
    min-height: 100vh;
    padding-top: 70px; /* Adjust if TopNav height changes */
    padding-left: 260px; /* For SideNav */
    width: 100%;
    box-sizing: border-box;
  }
  .main-container {
    background-color: white;
    margin: 1rem; /* Add some margin around the main content area */
    padding: 0; /* Remove padding if card has its own */
    border-radius: 8px;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }
  .articulo-principal > .card {
      box-shadow: none !important; /* Remove double shadow if main-container has one */
      border: none !important;
  }
  
  /* Professional Info Header */
  .professional-info-header {
    display: flex;
    flex-direction: column;
  }
  .professional-description {
    margin-top: 0.75rem;
    color: #555;
    max-width: 600px;
  }
  .contact-moderation-alert {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    margin-top: 0.75rem;
    border: 1px solid #f1c40f;
    border-radius: 8px;
    background: #fff8db;
    color: #7a5200;
    font-size: 0.88rem;
    font-weight: 600;
    padding: 0.45rem 0.65rem;
  }
  .professional-tax-summary {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
  }
  .status-pill {
    display: inline-flex;
    align-items: center;
    padding: 0.35rem 0.75rem;
    border-radius: 999px;
    font-size: 0.8rem;
    font-weight: 600;
    line-height: 1.1;
  }
  .status-pill-independent {
    background: #e6f4ea;
    color: #1f7a3d;
  }
  .status-pill-company {
    background: #e8f0fe;
    color: #1a5bb8;
  }
  .status-pill-unknown {
    background: #f1f3f5;
    color: #5f6368;
  }
  .status-pill-verified {
    background: #eaf7ef;
    color: #20744a;
  }
  .status-pill-pending {
    background: #fff5e6;
    color: #a56600;
  }
  .status-pill-not-verified {
    background: #fdecea;
    color: #b3261e;
  }
  .professional-description-text {
    white-space: pre-line;
    color: #555;
  }
  .professional-avatar {
    width: 80px; /* Smaller avatar */
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid #fff;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    margin-right: 1rem;
  }
  .professional-info-header .d-flex h2 {
    font-size: 1.75rem; /* Adjusted title size */
  }
  .professional-actions .btn {
    margin-right: 0.5rem;
    margin-bottom: 0.5rem; /* For wrapping on small screens */
  }


  /* Styles for new list sections */
  .visit-card, .response-card, .payment-card {
    border-radius: 6px;
    /* box-shadow: 0 2px 5px rgba(0,0,0,0.05); */
    transition: box-shadow 0.2s ease-in-out;
  }
  .visit-card:hover, .response-card:hover, .payment-card:hover {
    /* box-shadow: 0 4px 10px rgba(0,0,0,0.1); */
  }
  .visit-card h5, .response-card h5, .payment-card h5 {
    font-size: 1.1rem;
    font-weight: 500;
  }
  .list-group-item {
      background-color: #fff; /* Ensure items are white on sectionv background */
      border: 1px solid #ddd; /* Clearer borders for list items */
  }
  
  .archivos-table {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
    font-size: 0.9rem; /* Compact font size */
    text-align: left;
  }
  .archivos-table th, .archivos-table td {
    padding: 8px 12px; /* Reduced padding */
    border-bottom: 1px solid #e0e0e0;
  }
  .archivos-table th {
    background-color: #f4f6f8;
    font-weight: 500;
    letter-spacing: 0.03em;
  }

  .edit-profile-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
  }
  .edit-profile-photo {
    max-width: 220px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .photo-preview {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid #fff;
    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
    background-color: #f1f3f5;
  }
  .edit-profile-fields {
    flex: 1;
    min-width: 260px;
  }
  .edit-profile-name-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 0 1rem;
  }
  .description-input {
    min-height: 120px;
  }
  .company-visibility-status {
    display: inline-flex;
    align-items: center;
    border-radius: 999px;
    padding: 0.4rem 0.75rem;
    font-size: 0.82rem;
    font-weight: 600;
    white-space: nowrap;
  }
  .company-visible {
    background: #eaf7ef;
    color: #20744a;
  }
  .company-hidden {
    background: #f1f3f5;
    color: #666;
  }
  .company-summary {
    display: grid;
    grid-template-columns: 150px minmax(0, 1fr);
    gap: 1.5rem;
    padding: 1.25rem;
    border: 1px solid #e5e9ee;
    border-radius: 10px;
    background: #fbfcfd;
  }
  .company-logo-card {
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }
  .company-logo {
    width: 130px;
    height: 130px;
    border-radius: 12px;
    object-fit: cover;
    border: 1px solid #dfe5eb;
    background: #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  }
  .company-logo-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2867b2;
    background: #edf5ff;
    font-size: 2rem;
    font-weight: 700;
  }
  .company-information {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem 1.5rem;
    align-content: start;
  }
  .company-information-item {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }
  .company-information-item strong {
    margin-bottom: 0.2rem;
    color: #4d5966;
    font-size: 0.82rem;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
  .company-information-item span,
  .company-information-item a {
    overflow-wrap: anywhere;
  }
  .company-information-name span {
    font-size: 1.2rem;
    font-weight: 600;
    color: #253342;
  }
  .company-information-description {
    grid-column: 1 / -1;
  }
  .company-information-description span {
    white-space: pre-line;
  }
  .company-editor {
    margin-top: 1.5rem;
    padding-top: 1.5rem;
    border-top: 1px solid #e5e9ee;
  }
  .company-editor h3 {
    margin-bottom: 1rem;
    font-size: 1.15rem;
  }
  .company-edit-grid {
    display: grid;
    grid-template-columns: 220px minmax(0, 1fr);
    gap: 1.5rem;
  }
  .company-logo-editor {
    min-width: 0;
  }
  .company-logo-preview {
    display: flex;
    width: 180px;
    height: 180px;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border: 2px dashed #cbd5df;
    border-radius: 12px;
    color: #2867b2;
    background: #f6f9fc;
    font-size: 2rem;
    font-weight: 700;
  }
  .company-logo-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .company-logo-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-top: 1rem;
  }
  .company-visibility-toggle {
    display: flex;
    align-items: flex-start;
    gap: 0.55rem;
    margin-bottom: 1rem;
    padding: 0.85rem 1rem;
    border-radius: 8px;
    background: #f4f8fc;
    cursor: pointer;
  }
  .company-visibility-toggle input {
    margin-top: 0.2rem;
  }
  .company-fields-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0 1rem;
  }
  .company-web-field,
  .company-description-field {
    grid-column: 1 / -1;
  }
  .company-description-field textarea {
    min-height: 110px;
  }
  
  
  @media (max-width: 800px) {
    .column-right {
      padding-left: 0px;
    }
    .professional-info-header .d-flex {
      flex-direction: column;
      align-items: flex-start;
    }
    .professional-avatar {
      margin-bottom: 0.5rem;
    }
    .professional-actions {
      display: flex;
      flex-direction: column;
    }
    .professional-actions .btn {
      width: 100%;
      margin-bottom: 0.5rem;
    }
    .professional-actions .btn:last-child {
      margin-bottom: 0;
    }
    .edit-profile-grid {
      flex-direction: column;
      align-items: center;
    }
    .edit-profile-photo {
      max-width: none;
      align-items: center;
    }
    .photo-preview {
      width: 140px;
      height: 140px;
    }
    .edit-profile-fields {
      width: 100%;
    }
    .company-summary,
    .company-edit-grid {
      grid-template-columns: 1fr;
    }
    .company-logo-card {
      justify-content: flex-start;
    }
    .company-logo-editor {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    .company-information,
    .company-fields-grid {
      grid-template-columns: 1fr;
    }
    .company-information-description,
    .company-web-field,
    .company-description-field {
      grid-column: auto;
    }
    .section-header,
    .activity-item {
      flex-direction: column;
      align-items: stretch;
    }
    .bank-account-field {
      grid-column: auto;
    }
    .activity-status,
    .activity-side,
    .bank-status,
    .activity-count,
    .points-balance {
      align-self: flex-start;
      align-items: flex-start;
      text-align: left;
    }
  }
  </style>
